import _mergeJSXProps from 'babel-helper-vue-jsx-merge-props';

var AllIcon = {
  name: 'AllIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather custom-all-icon"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -60)"}}, [
          h("g", {attrs: {transform: "translate(10252.62 -16661.277)", class: "custom-icon-g"}}, [
            h("path", {
              attrs: {
                d: "M39.542,26.009l-.391-.092-.4-.094-.4-.088-.4-.083-.4-.077-.408-.07-.41-.068-.414-.062-.414-.056-.427-.049-.427-.045-.427-.036-.427-.032-.427-.026-.427-.019-.427-.013H31.636l-.442.013-.44.023-.446.026-1.068.09-1.068.13-1.044.171-1.031.214-1.014.241-1,.275-.978.308-.959.342-.937.374-.914.4-.893.427-.865.459-.839.487-.811.515-.782.54-.75.56-.718.585-.681.6-.641.626-.611.641-.572.662-.53.681-.493.694-.446.713-.408.724-.359.739-.314.75-.263.758-.214.769-.162.779-.109.786L8.78,42,.81,35.879l.062-.9L1,34.085,1.19,33.2l.239-.88.3-.854.354-.854.408-.839.459-.824.51-.807.56-.792.606-.775.641-.752.692-.732.737-.711.775-.688.818-.666.854-.641.888-.611.92-.585.952-.553.984-.523,1.01-.491,1.04-.455,1.068-.427,1.089-.389L18.206,18l1.134-.314,1.153-.275,1.172-.233,1.185-.19,1.2-.149,1.211-.107.5-.03.5-.023.5-.013h1.484l.491.017.487.019.487.03.485.038.48.043.478.049.474.058.472.062.468.07.466.075.461.083.459.088.455.094.453.1.448.1.442.113.442.12.427.122.427.13.427.137.427.143.427.145.427.152.41.156.4.162.4.169.1.043.1.043.109.045.113.045.12.045.126.045.13.043.132.038.139.038.143.032.145.03.149.023.156.017h.48l.164-.017.169-.03.171-.036L42.8,19.5l.175-.062.175-.075.177-.09.177-.1.182-.12.177-.137.182-.152.182-.171.182-.19.182-.214.177-.229.938-.905L47.612,26l-.158.214-.158.2-.158.184-.158.164-.162.152-.158.132-.158.12-.156.107-.158.09-.156.081-.156.064-.152.056-.152.043-.149.036-.149.023-.145.013H44.7l-.132-.017-.132-.019-.13-.026-.126-.03-.12-.032-.12-.036-.113-.036-.109-.038-.1-.043-.1-.038-.1-.038-.09-.038-.088-.036-.352-.149-.354-.143-.361-.137-.365-.137-.372-.126-.372-.126-.378-.12-.378-.113-.384-.109Z",
                transform: "translate(-10127.167 16715.045)"
              }
            }),
            h("path", {
              attrs: {
                d: "M33.542,72.053l.792-.547.762-.573.729-.6.7-.616.651-.638.621-.654.582-.675.542-.695.5-.708.456-.728.41-.739.365-.754.319-.765.269-.773.217-.784.167-.8.111-.8.056-.808,8.091,6.233-.065.917-.128.913-.187.9-.25.893-.306.882-.358.871-.417.856-.467.841-.508.81-.569.808-.614.791-.651.767-.705.747-.749.725-.788.7-.827.68-.868.654-.9.623-.935.6-.968.564-1,.534-1.031.5-1.057.464-1.085.436-1.109.4-1.128.355-1.152.32-1.172.281L28.7,84.7l-1.209.194-1.217.152-1.235.109-.512.031-.512.024-.506.013H21.994l-.5-.017L21,85.188l-.495-.03-.488-.039-.488-.044-.486-.05-.493-.065-.48-.063-.475-.072-.475-.076-.48-.081-.467-.089-.462-.1-.456-.1L14.8,84.27l-.453-.115-.447-.122-.434-.124-.434-.133-.434-.139-.434-.146-.434-.148-.427-.157-.417-.159-.414-.166-.408-.172-.1-.044-.1-.044-.111-.046-.115-.046-.122-.046-.124-.046-.132-.044-.139-.039L8.981,82.3l-.143-.026-.152-.031-.152-.024L8.38,82.2H7.894l-.167.017-.171.031-.171.037-.178.052-.178.063-.178.076-.18.092-.18.1-.18.122-.184.139-.18.155-.184.174-.184.194-.184.218-.184.233-.184.253L2.32,75.7l.161-.218.165-.218.161-.187.161-.168.161-.155.161-.135.161-.122.161-.109.158-.092.158-.083.158-.07.158-.057L4.4,74.04,4.548,74l.148-.024.152-.013h.427l.139.013.135.02.132.026.124.031.124.033.117.037.115.039.111.037.108.044.1.039.1.039.091.039.085.039.358.148.365.146.367.139.371.139.373.129.378.129.384.122.386.115.391.111.395.1.4.1.4.1.4.089.408.085.41.078.414.072.417.07.417.063.434.057.434.05.434.046.434.039.434.031.434.026.434.02.434.013h1.315l.447-.013.449-.02.449-.026,1.085-.1,1.074-.133,1.061-.172,1.048-.218,1.031-.244,1.013-.283.994-.314.974-.349.955-.379.929-.412.907-.436.879-.468.853-.5Z",
                transform: "translate(-10128.939 16686.119)"
              }
            }),
          ]),

          h("g", {attrs: {transform: "translate(10252.62 -16661.277)", class: "custom-icon-g-internal"}}, [
            h("path", {
              attrs: {
                d: "M242.857,223.809c-1.975,2.776-3.258,3.46-4.289,3.032a34.109,34.109,0,0,0-15.121-2.407c-13.366.869-24.768,9.507-25.135,19.136-2.247-12.6,9.987-23.621,24.676-24.535C230.794,218.549,237.6,219.516,242.857,223.809Z",
                transform: "translate(-10324.664 16507.355)"
              }
            }),
            h("path", {
              attrs: {
                d: "M209.093,316.883c1.971-2.776,3.137-3.327,4.168-2.9a33.982,33.982,0,0,0,15.092,2.407c13.34-.869,24.725-9.507,25.087-19.136,2.242,12.6-9.968,23.621-24.629,24.535C221.02,322.271,214.337,321.167,209.093,316.883Z",
                transform: "translate(-10332.51 16454.379)"
              }
            }),
          ]),
        ])
      ]);
  }
};

var AcucarIcon = {
  name: 'AcucarIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
      },
      "class": "feather"
    }, ctx.data]), [
      h("g", {attrs: {transform: "translate(-120 -120)"}}, [
        h("path", {
          attrs: {
            d: "M48.616,4.459a15.394,15.394,0,0,0-3.631-2.887C42.634.2,40.516-.316,39.32.191a1.558,1.558,0,0,0-.946,1.083c-.008.026-.015.052-.02.079L37.022,8.505a6.012,6.012,0,0,1-.825,2.1,1.292,1.292,0,0,0-.135,1.1,1.3,1.3,0,0,0-.269,1.074,5.878,5.878,0,0,1,.015,2.242l-1,5.391-.222-1.195a5.88,5.88,0,0,1,.015-2.243,1.3,1.3,0,0,0-.269-1.074,1.291,1.291,0,0,0-.135-1.1,6.009,6.009,0,0,1-.825-2.1l-1.3-6.969a.747.747,0,0,0-.02-.08A1.557,1.557,0,0,0,31.1,4.568c-1.2-.508-3.313.008-5.665,1.381a15.383,15.383,0,0,0-3.631,2.887c-.726.811-1.55,2-1.355,3.041l.538,2.889a5.878,5.878,0,0,1-.015,2.242,1.3,1.3,0,0,0,.269,1.075,1.292,1.292,0,0,0,.136,1.1,6,6,0,0,1,.824,2.1l1.443,7.744-1.4-1.678a5.871,5.871,0,0,0-8.887,0l-3.347,4A63.17,63.17,0,0,0,1.7,44.128L.193,47.208a1.867,1.867,0,0,0,.135,1.885A2.1,2.1,0,0,0,2.079,50H3.423a.734.734,0,1,0,0-1.465H2.079a.53.53,0,0,1-.447-.232.472.472,0,0,1-.034-.481L3.1,44.743a61.714,61.714,0,0,1,8.118-12.485l3.347-4a4.268,4.268,0,0,1,6.461,0l3.348,4c.16.191.317.384.475.576l.006.007a61.637,61.637,0,0,1,7.637,11.9l.753,1.539,0,.005L34,47.823a.472.472,0,0,1-.035.481.528.528,0,0,1-.447.232H6.965a.734.734,0,1,0,0,1.465H33.519a2.1,2.1,0,0,0,1.751-.908,1.867,1.867,0,0,0,.135-1.885l-.333-.682,3.559-.594a1.423,1.423,0,0,0,1.053-.769,1.293,1.293,0,0,0-.071-1.258,6.079,6.079,0,0,1-.481-.938l3.2.535a1.522,1.522,0,0,0,.248.021,1.473,1.473,0,0,0,1.019-.4,1.308,1.308,0,0,0,.388-1.2,5.886,5.886,0,0,1-.015-2.242l1.5-8.035a6,6,0,0,1,.825-2.1,1.293,1.293,0,0,0,.135-1.1,1.3,1.3,0,0,0,.269-1.075,5.878,5.878,0,0,1-.015-2.242l.681-3.656a.737.737,0,0,0-.628-.848.771.771,0,0,0-.9.594l-.681,3.656a7.267,7.267,0,0,0-.01,2.614l-9.322-1.556-.286-1.536a7.311,7.311,0,0,0,.29-1.078l1.5-8.035a7.258,7.258,0,0,0,.01-2.614L47.6,14.373a7.4,7.4,0,0,0-.935,2.459l-.18.965a.737.737,0,0,0,.628.849.818.818,0,0,0,.135.011.764.764,0,0,0,.761-.605l.18-.965a6,6,0,0,1,.825-2.1,1.291,1.291,0,0,0,.135-1.1,1.3,1.3,0,0,0,.269-1.075,5.878,5.878,0,0,1-.015-2.242l.572-3.07h0C50.165,6.456,49.341,5.27,48.616,4.459ZM22.052,11.7c-.066-.027-.068-.041-.075-.08-.132-.71,1.467-2.787,4.275-4.426C28.478,5.9,30.02,5.714,30.469,5.9c.066.028.068.041.075.08h0c.132.71-1.468,2.788-4.275,4.426C24.043,11.712,22.5,11.894,22.052,11.7Zm.463,2.809-.24-1.287c.071,0,.143.007.218.007a9.888,9.888,0,0,0,4.59-1.572,15.394,15.394,0,0,0,3.631-2.887c.095-.106.192-.219.287-.337l.842,4.52a7.405,7.405,0,0,0,.934,2.46L22.525,17.126A7.257,7.257,0,0,0,22.514,14.512Zm3.076,16.837-.27-.323a7.272,7.272,0,0,0-.095-1.962l-1.5-8.035a7.4,7.4,0,0,0-.935-2.46l10.253-1.711a7.257,7.257,0,0,0,.01,2.614l1.5,8.035a7.4,7.4,0,0,0,.935,2.459l-9.7,1.619Zm19.294-2.425a7.411,7.411,0,0,0-.934,2.46l-1.5,8.035a7.266,7.266,0,0,0-.011,2.614l-3.726-.622-1.424-7.642a5.886,5.886,0,0,1,.015-2.242,1.3,1.3,0,0,0-.269-1.075,1.292,1.292,0,0,0-.135-1.1,6.011,6.011,0,0,1-.78-1.892Zm-9.127,2.485a7.248,7.248,0,0,0,.011,2.614l1.5,8.035a7.4,7.4,0,0,0,.934,2.46l-3.8.634-.5-1.023A63.066,63.066,0,0,0,26.845,32.9ZM47.875,10.316a7.267,7.267,0,0,0-.011,2.614L37.612,11.219a7.405,7.405,0,0,0,.934-2.46l.876-4.7c.1.118.193.231.287.337a15.384,15.384,0,0,0,3.631,2.887,9.888,9.888,0,0,0,4.59,1.572c.075,0,.147,0,.218-.007Zm.572-3.07v0c-.007.038-.011.051-.075.079-.449.191-1.991.009-4.218-1.292C41.346,4.4,39.746,2.319,39.879,1.609c.007-.039.01-.053.075-.08a1.136,1.136,0,0,1,.427-.064,8.421,8.421,0,0,1,3.791,1.355C46.979,4.458,48.579,6.535,48.447,7.246Zm0,0",
            transform: "translate(125 125)",
          }
        }),
      ]),
    ]);
  }
};

var AlgodaoIcon = {
  name: 'AlgodaoIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]), [
        h("g", {attrs: {transform: "translate(-120 -240)"}}, [
          h("g", {attrs: {transform: "translate(125 245)"}}, [
            h("path", {
              attrs: {
                d: "M50,24.426a18.042,18.042,0,0,0-3.549-10.867,16.417,16.417,0,0,0-8.789-6.078,16.843,16.843,0,0,0-3.955-3.717A15.6,15.6,0,0,0,25,1.1,15.99,15.99,0,0,0,12.348,7.478a16.413,16.413,0,0,0-8.79,6.069A18.04,18.04,0,0,0,0,24.426,17.569,17.569,0,0,0,9.964,40.509a13.958,13.958,0,0,1-3.752.673.741.741,0,0,0-.706.573.805.805,0,0,0,.329.879c5.43,3.476,11.61,3.048,14.81,2.485a1.691,1.691,0,0,1,1.435.422,1.931,1.931,0,0,1,.621,1.434v3.34a.734.734,0,1,0,1.465,0v-5.23a4.025,4.025,0,0,0-3.313-4.078,14.424,14.424,0,0,1-7.484-3.185.7.7,0,0,0-1.029.125.817.817,0,0,0,.118,1.1,14.337,14.337,0,0,0,1.459,1.083c-7.057-1.26-12.452-7.821-12.452-15.7A16.426,16.426,0,0,1,4.7,14.52,15.144,15.144,0,0,1,10.943,9.6,18.259,18.259,0,0,0,8.611,18.58a18.557,18.557,0,0,0,1.177,6.511A12.457,12.457,0,0,1,7.58,23.109l-.067-.071a.7.7,0,0,0-.783-.176.78.78,0,0,0-.466.694c-.012.3-.253,7.47,3.881,13.015a.7.7,0,0,0,1.029.125.817.817,0,0,0,.117-1.1,20.141,20.141,0,0,1-3.5-10.131c1.515,1.355,3.851,2.752,9.234,3.9a8.445,8.445,0,0,1,6.3,5.143,11.741,11.741,0,0,1,.935,4.112.734.734,0,1,0,1.465,0,11.6,11.6,0,0,1,.913-4.061,8.449,8.449,0,0,1,6.327-5.194c5.387-1.149,7.723-2.547,9.237-3.9a22.763,22.763,0,0,1-1.357,6.173A15.127,15.127,0,0,1,37,37.5a14.282,14.282,0,0,1-7.852,3.51,4.025,4.025,0,0,0-3.313,4.078v5.23a.734.734,0,1,0,1.465,0v-3.34a1.931,1.931,0,0,1,.621-1.434,1.691,1.691,0,0,1,1.435-.422c3.2.564,9.38.991,14.81-2.485a.8.8,0,0,0,.329-.879.741.741,0,0,0-.706-.573,13.806,13.806,0,0,1-3.753-.672A17.569,17.569,0,0,0,50,24.426ZM20.664,42.556a2.355,2.355,0,0,1,1.781,1.371,3.059,3.059,0,0,0-2.038-.351A20.73,20.73,0,0,1,8.735,42.441a15.532,15.532,0,0,0,3.418-1.125,15.391,15.391,0,0,0,4.236.593c.4,0,.809-.016,1.21-.048A18.285,18.285,0,0,0,20.664,42.556Zm20.6-.114a20.732,20.732,0,0,1-11.672,1.135,3.06,3.06,0,0,0-2.038.351,2.355,2.355,0,0,1,1.781-1.371,18.2,18.2,0,0,0,3.069-.694c.4.031.8.048,1.206.048a15.391,15.391,0,0,0,4.236-.593A15.539,15.539,0,0,0,41.265,42.441Zm-5.2-2.312a16.1,16.1,0,0,0,6.139-7.9,24.085,24.085,0,0,0,1.528-8.669.78.78,0,0,0-.466-.694.7.7,0,0,0-.783.176l-.067.071a12.455,12.455,0,0,1-2.209,1.982,18.659,18.659,0,0,0,.661-10.883.73.73,0,0,0-.892-.562.787.787,0,0,0-.527.951,16.994,16.994,0,0,1,.47,3.982,16.772,16.772,0,0,1-1.834,7.649,29.43,29.43,0,0,1-5.405,1.606,10,10,0,0,0-7.373,6.08c-.116.273-.22.543-.312.808-.092-.265-.2-.535-.312-.808a10,10,0,0,0-7.373-6.08,29.438,29.438,0,0,1-5.405-1.606,16.773,16.773,0,0,1-1.834-7.649C10.076,9.8,16.771,2.659,25,2.659a14.2,14.2,0,0,1,7.927,2.429,15.652,15.652,0,0,1,5.4,6.325.711.711,0,0,0,.984.345.807.807,0,0,0,.324-1.05q-.267-.564-.571-1.1A15.148,15.148,0,0,1,45.3,14.531a16.429,16.429,0,0,1,3.231,9.895C48.535,32.311,43.133,38.875,36.069,40.13Z",
                transform: "translate(0 -1.096)",
              }
            }),
          ]),
        ])
      ]
    );
  }
};

var ArrozIcon = {
  name: 'ArrozIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -300)"}}, [
          h("path", {
            attrs: {
              d: "M71.16,24.312a.977.977,0,0,0-1.388-.8,21.877,21.877,0,0,0-3.064,1.759,35.885,35.885,0,0,0,.247-17.027.977.977,0,0,0-1.643-.44,30.162,30.162,0,0,0-4.3,5.651c0-.232.01-.465.01-.7A22.943,22.943,0,0,0,57.687.447a.977.977,0,0,0-1.641,0A21.069,21.069,0,0,0,53.178,7.84,10.581,10.581,0,0,0,42.733,5.882h-.039a7.893,7.893,0,0,0-5.545-4.441A8.109,8.109,0,0,0,30.005,4.18a.977.977,0,0,0-.193,1.095A10.2,10.2,0,0,0,31.82,8.219a6.654,6.654,0,0,0-.992.348,8.109,8.109,0,0,0-4.42,6.256.977.977,0,0,0,.45,1.016A10.675,10.675,0,0,0,29.4,16.99c-.052.048-.1.1-.154.149a8.109,8.109,0,0,0-1.882,7.418.977.977,0,0,0,.786.786c.234.042.463.077.691.1a8.3,8.3,0,0,0-1.477,6.972.977.977,0,0,0,.786.786,11.171,11.171,0,0,0,2,.193,8.794,8.794,0,0,0,2.257-.284,6.682,6.682,0,0,0-.22,1.7A8.109,8.109,0,0,0,36.1,41.389a.977.977,0,0,0,1.11,0,8.109,8.109,0,0,0,3.914-6.576,6.682,6.682,0,0,0-.22-1.7,8.794,8.794,0,0,0,2.257.284,11.179,11.179,0,0,0,2-.193.975.975,0,0,0,.786-.786,8.3,8.3,0,0,0-1.477-6.972c.228-.029.458-.062.691-.1a.975.975,0,0,0,.786-.786,8.632,8.632,0,0,0-.99-6.312,10.459,10.459,0,0,0,1.435-.162.977.977,0,0,0,.786-.786,10.174,10.174,0,0,0,.172-1.852c.209.015.419.025.633.025a10.158,10.158,0,0,0,1.821-.17.977.977,0,0,0,.786-.786,7.426,7.426,0,0,0-1.738-6.8l-.137-.133a8.658,8.658,0,0,1,6.194,8.289V33.5a18.134,18.134,0,0,0-4.711-6.281.977.977,0,0,0-1.525.361A19.163,19.163,0,0,0,47.84,39.5a19.845,19.845,0,0,0,4.329,8.551H36.661a.977.977,0,0,0,0,1.954H67.908a.977.977,0,1,0,0-1.954H59.591a26.187,26.187,0,0,0,5.536-5.25.977.977,0,0,0-1.531-1.213,23.448,23.448,0,0,1-6.721,5.871V47.39a22.59,22.59,0,0,1,.965-6.491.8.8,0,0,0,.025-.081,26.848,26.848,0,0,1,2.471-5.694,26.228,26.228,0,0,1,5.238-6.485.943.943,0,0,0,.1-.087,21.7,21.7,0,0,1,3.612-2.585,23.463,23.463,0,0,1-1.749,8.82.977.977,0,0,0,1.813.724,24.766,24.766,0,0,0,1.811-11.2ZM36.834,3.378a5.935,5.935,0,0,1,4.055,3.255,5.935,5.935,0,0,1-4.92,1.7,5.935,5.935,0,0,1-4.055-3.255,5.935,5.935,0,0,1,4.92-1.7Zm1.784,11.681q-.465,0-.948.048a8.578,8.578,0,0,1,.3-1.622,6.636,6.636,0,0,0,.649,1.574ZM28.48,14.507a5.935,5.935,0,0,1,3.141-4.142,5.935,5.935,0,0,1,5.186.456,5.935,5.935,0,0,1-3.147,4.147,4.663,4.663,0,0,1-.84.278l-.125.027a6.416,6.416,0,0,1-4.213-.761Zm2.149,4.008A5.037,5.037,0,0,1,33.1,17.183l.048-.01a7.586,7.586,0,0,1,2.485-.106,5.935,5.935,0,0,1-1.442,5A4.933,4.933,0,0,1,32.1,23.292l-.095.029a7.35,7.35,0,0,1-2.823.193A5.935,5.935,0,0,1,30.629,18.516ZM29.187,31.38a5.935,5.935,0,0,1,1.442-5,4.947,4.947,0,0,1,2.151-1.24h.031a7.351,7.351,0,0,1,2.829-.193A6.209,6.209,0,0,1,34.6,29.488q-.3.3-.57.616a6.032,6.032,0,0,1-4.844,1.276Zm7.476,7.982a5.935,5.935,0,0,1-2.51-4.557,5.306,5.306,0,0,1,1.317-3.383c.037-.035.073-.068.108-.1a6.709,6.709,0,0,0,.473-.527,7.319,7.319,0,0,1,.618-.544c.22.176.427.359.618.544a6.755,6.755,0,0,0,.473.527l.108.1A5.308,5.308,0,0,1,39.182,34.8a5.935,5.935,0,0,1-2.522,4.559Zm7.476-7.982a6.03,6.03,0,0,1-4.827-1.286q-.266-.315-.57-.616A6.211,6.211,0,0,1,37.7,24.935a7.349,7.349,0,0,1,2.825.193l.044.014a4.945,4.945,0,0,1,2.124,1.238,5.935,5.935,0,0,1,1.442,5Zm0-7.862a7.352,7.352,0,0,1-2.825-.193l-.091-.027a4.931,4.931,0,0,1-2.087-1.222,5.935,5.935,0,0,1-1.442-5,5.935,5.935,0,0,1,5,1.442,5.935,5.935,0,0,1,1.44,5Zm1.226-7.264a5.254,5.254,0,0,1-4.381-1.288A5.256,5.256,0,0,1,39.7,10.586a5.256,5.256,0,0,1,4.381,1.288,5.256,5.256,0,0,1,1.286,4.381Zm3.41-2.778a7.09,7.09,0,0,1-1.657-.015,6.372,6.372,0,0,0-1.66-2.968,6.565,6.565,0,0,0-3.927-1.84,8.623,8.623,0,0,1,1.66-.855,5.213,5.213,0,0,1,4.294,1.3,5.256,5.256,0,0,1,1.288,4.381Zm5.385,33.839a17.651,17.651,0,0,1-4.414-8.271,17.645,17.645,0,0,1,.239-9.372,18.385,18.385,0,0,1,4.172,17.645Zm.7-37.662a1.044,1.044,0,0,0,.023-.118A20.659,20.659,0,0,1,56.872,2.93a21.831,21.831,0,0,1,2.2,9.818,23.291,23.291,0,0,1-.965,6.707q-.353.919-.666,1.865-.266.639-.579,1.241v-6.7a10.536,10.536,0,0,0-2-6.213ZM64.553,25.82c-.133.5-.278.994-.431,1.487a28.23,28.23,0,0,0-5.481,6.831q-.714,1.238-1.3,2.51a37.737,37.737,0,0,1,1.269-12.426q.305-1.137.668-2.24a18.438,18.438,0,0,0,.676-1.894,33.562,33.562,0,0,1,5.507-9.559,35.75,35.75,0,0,1-.911,15.3Z",
              transform: "translate(101.609 305)",
            }
          }),
        ]),
      ],
    );
  }
};

//

var BioenergiaIcon = {
  name: 'BioenergiaIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -360)"}}, [
          h("g", {attrs: {transform: "translate(125 357.574)"}}, [
            h("path", {
              attrs: {
                d: "M210.009,15.537a.863.863,0,0,0,.863-.863V.863a.864.864,0,1,0-1.727,0V14.674a.863.863,0,0,0,.865.863Zm0,0",
                transform: "translate(-184.534 8.426)",
              }
            }),
            h("path", {
              attrs: {
                d: "M82.008,15.536h5.178a4.3,4.3,0,0,0,2.563-7.768A4.3,4.3,0,0,0,87.186,0H82.008a.863.863,0,0,0-.863.863V14.673A.863.863,0,0,0,82.008,15.536Zm7.768-4.317a2.59,2.59,0,0,1-2.59,2.592H82.87V8.631h4.315a2.59,2.59,0,0,1,2.59,2.588ZM82.87,1.725h4.315a2.59,2.59,0,0,1,0,5.178H82.87Zm0,0",
                transform: "translate(-69.996 8.426)",
              }
            }),
            h("path", {
              attrs: {
                d: "M260.6,15.536h3.453a3.453,3.453,0,0,0,3.453-3.453V3.453A3.453,3.453,0,0,0,264.05,0H260.6a3.453,3.453,0,0,0-3.453,3.453v8.631a3.453,3.453,0,0,0,3.453,3.453ZM258.87,3.453A1.727,1.727,0,0,1,260.6,1.727h3.453a1.727,1.727,0,0,1,1.725,1.725v8.631a1.727,1.727,0,0,1-1.725,1.725H260.6a1.727,1.727,0,0,1-1.727-1.725Zm0,0",
                transform: "translate(-227.702 8.426)",
              }
            }),
            h("path", {
              attrs: {
                d: "M11.313,182.855l8.284,8.284v-5.754C16.732,184.4,13.749,183.524,11.313,182.855Zm0,0",
                transform: "translate(-9.971 -161.043)",
              }
            }),
            h("path", {
              attrs: {
                d: "M153.978,236.273a6.159,6.159,0,0,0-.833-.663v10.555l2.785,2.787C158.464,245.434,157.085,239.385,153.978,236.273Zm0,0",
                transform: "translate(-135.561 -207.885)",
              }
            }),
            h("path", {
              attrs: {
                d: "M97.145,209.746v6.984l4.739,4.739v-9.743A47.857,47.857,0,0,0,97.145,209.746Zm0,0",
                transform: "translate(-85.996 -184.928)",
              }
            }),
            h("path", {
              attrs: {
                d: "M33.871,280H26.887a47.931,47.931,0,0,0,1.98,4.739H38.61Zm0,0",
                transform: "translate(-23.701 -247.008)",
              }
            }),
            h("path", {
              attrs: {
                d: "M8.284,202.447,0,194.163c.663,2.438,1.548,5.421,2.519,8.284Zm0,0",
                transform: "translate(0 -171.067)",
              }
            }),
            h("path", {
              attrs: {
                d: "M66.1,338.785,63.315,336H52.762a6.256,6.256,0,0,0,.663.833C56.537,339.947,62.588,341.31,66.1,338.785Zm0,0",
                transform: "translate(-46.511 -296.58)",
              }
            }),
            h("path", {
              attrs: {
                d: "M186.1,359.947a.947.947,0,0,0-1.34,0l-1.062,1.062a10.429,10.429,0,0,0-2.107,3.044,10.431,10.431,0,0,0-2.107-3.044l-1.062-1.062a.948.948,0,0,0-1.34,1.34l1.062,1.062a8.48,8.48,0,0,1,2.5,6.032v4.605a.947.947,0,0,0,1.895,0v-4.605a8.48,8.48,0,0,1,2.5-6.032l1.062-1.062a.95.95,0,0,0,0-1.34Zm0,0",
                transform: "translate(-156.599 -317.867)",
              }
            }),
            h("path", {
              attrs: {
                d: "M361.424,182.855l-8.284,8.284v-5.754C356,184.4,358.985,183.524,361.424,182.855Zm0,0",
                transform: "translate(-312.775 -161.043)",
              }
            }),
            h("path", {
              attrs: {
                d: "M249.779,236.273a6.12,6.12,0,0,1,.833-.663v10.555l-2.787,2.787C245.293,245.434,246.667,239.384,249.779,236.273Zm0,0",
                transform: "translate(-218.204 -207.885)",
              }
            }),
            h("path", {
              attrs: {
                d: "M301.884,209.746v6.984l-4.739,4.739v-9.743a47.812,47.812,0,0,1,4.739-1.98Zm0,0",
                transform: "translate(-263.041 -184.928)",
              }
            }),
            h("path", {
              attrs: {
                d: "M313.2,280h6.984a47.8,47.8,0,0,1-1.98,4.739h-9.743Zm0,0",
                transform: "translate(-273.377 -247.008)",
              }
            }),
            h("path", {
              attrs: {
                d: "M364.457,202.447l8.284-8.284c-.663,2.438-1.548,5.421-2.519,8.284Zm0,0",
                transform: "translate(-322.741 -171.067)",
              }
            }),
            h("path", {
              attrs: {
                d: "M268.945,338.785,271.732,336h10.553a6.283,6.283,0,0,1-.663.833C278.51,339.947,272.46,341.31,268.945,338.785Zm0,0",
                transform: "translate(-238.546 -296.58)",
              }
            }),
          ]),
        ])
      ],
    );
  }
};
var BoiIcon = {
  name: 'BoiIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -420)"}}, [
          h("g", {attrs: {transform: "translate(112.839 -211)"}}, [
            h("path", {
              attrs: {
                d: "M49.13,16.055a1.641,1.641,0,0,0-1.049-.729,16.965,16.965,0,0,0-3.286-.372H44.51a.683.683,0,0,0,.006,1.366h.269a15.58,15.58,0,0,1,3.016.343.268.268,0,0,1,.173.119.244.244,0,0,1,.031.191,9.954,9.954,0,0,1-8.133,7.619,20.182,20.182,0,0,0-.534-5.87q-.124-.49-.275-.96a9.679,9.679,0,0,1,2.406-1.028A.683.683,0,0,0,41.1,15.42a11.145,11.145,0,0,0-2.525,1.043c-.069-.163-.143-.322-.217-.481a13.405,13.405,0,0,0,2.6-9.723,13.826,13.826,0,0,0-1.4-4.9L39.236.684a1.228,1.228,0,0,0-2.3.27,16.106,16.106,0,0,1-2.33,5.5,8.939,8.939,0,0,1-3.215,2.9A16.162,16.162,0,0,0,27.908,8.3a16.376,16.376,0,0,0-5.765-.105A18.922,18.922,0,0,0,18.067,9.4a8.91,8.91,0,0,1-3.3-2.943,16.113,16.113,0,0,1-2.33-5.5,1.228,1.228,0,0,0-2.3-.27L9.81,1.36a13.828,13.828,0,0,0-1.4,4.9,13.419,13.419,0,0,0,2.574,9.685,4.588,4.588,0,0,0-.243.48,13.252,13.252,0,0,0-9.448-1.1,1.644,1.644,0,0,0-1.049.728,1.6,1.6,0,0,0-.2,1.245,12.1,12.1,0,0,0,2.589,5.016A11.447,11.447,0,0,0,9.628,26c.027.261.057.523.092.784a21.783,21.783,0,0,0,.694,3.461,47.387,47.387,0,0,1,1.765,7.766,9.054,9.054,0,0,0-.357,6.8,7.677,7.677,0,0,0,6.481,5,.683.683,0,1,0,.212-1.35A6.317,6.317,0,0,1,13.1,44.325a7.741,7.741,0,0,1,2.165-8.2,11.083,11.083,0,0,1,4.12-1.964,19.717,19.717,0,0,1,10.607,0,11.077,11.077,0,0,1,4.12,1.964,7.741,7.741,0,0,1,2.165,8.2c-1.071,2.83-3.44,4.23-7.242,4.28-2.46.032-4.853.037-7.317.015h-.006a.683.683,0,0,0-.006,1.366c1.008.009,2,.013,3,.013,1.445,0,2.885-.01,4.349-.029,4.367-.057,7.228-1.794,8.5-5.162a9.053,9.053,0,0,0-.352-6.785.7.7,0,0,0,.043-.182A47.887,47.887,0,0,1,39,30.249a14.923,14.923,0,0,0,.366-1.483q.274-1.42.407-2.768a11.441,11.441,0,0,0,6.972-3.683A12.1,12.1,0,0,0,49.333,17.3,1.6,1.6,0,0,0,49.13,16.055ZM35.728,7.24a17.229,17.229,0,0,0,2.453-5.607l.165.333A12.463,12.463,0,0,1,39.6,6.382a12.151,12.151,0,0,1-1.963,8.274,13.252,13.252,0,0,0-4.343-4.3c-.146-.091-.294-.178-.444-.263A10.668,10.668,0,0,0,35.728,7.24ZM9.776,6.382a12.459,12.459,0,0,1,1.259-4.417l.165-.333A17.227,17.227,0,0,0,13.652,7.24a10.629,10.629,0,0,0,2.932,2.889,13.317,13.317,0,0,0-4.755,4.377l-.081.126-.007.012A12.174,12.174,0,0,1,9.776,6.382Zm-8.4,10.592a.244.244,0,0,1,.031-.191.268.268,0,0,1,.173-.119,15.3,15.3,0,0,1,3.143-.34,11.248,11.248,0,0,1,4.531.889,9.159,9.159,0,0,1,1.035.533l-.13.45a16.845,16.845,0,0,0-.55,2.8,21.413,21.413,0,0,0-.113,3.085c.006.174.015.347.024.52A9.956,9.956,0,0,1,1.374,16.974Zm9.682,9.471a20.215,20.215,0,0,1,.228-7.139,12.477,12.477,0,0,1,4.306-6.837,13.644,13.644,0,0,1,3.617-2.087,14.31,14.31,0,0,1,4.868-1l.07,0a10.118,10.118,0,0,0,.266,4.561c.605,2.433.04,3.514-.54,3.992a4.336,4.336,0,0,1-2.451.646,8.641,8.641,0,0,0-2.175.357,7.1,7.1,0,0,0-3.435,3.124c-.191.3-.377.614-.555.914a11.855,11.855,0,0,1-1.765,2.473,4.038,4.038,0,0,1-2.435,1S11.057,26.446,11.057,26.445Zm26.966,2.062a13.515,13.515,0,0,1-.332,1.346A60.9,60.9,0,0,0,36.1,36.2a7.432,7.432,0,0,0-1.125-1.143,12.394,12.394,0,0,0-4.619-2.221,21.071,21.071,0,0,0-11.333,0A12.392,12.392,0,0,0,14.4,35.061a7.409,7.409,0,0,0-1.1,1.109,61.266,61.266,0,0,0-1.585-6.319c-.127-.418-.225-.806-.3-1.184-.058-.293-.111-.581-.161-.867a5.316,5.316,0,0,0,3.188-1.373,13.04,13.04,0,0,0,1.982-2.75c.174-.293.354-.6.536-.883a5.617,5.617,0,0,1,2.723-2.562,7.511,7.511,0,0,1,1.835-.287,5.387,5.387,0,0,0,3.216-.955c1.267-1.044,1.612-2.9,1-5.376a8.649,8.649,0,0,1-.2-4.222,14.689,14.689,0,0,1,7.039,2.124,12.041,12.041,0,0,1,5.437,7.544A21.819,21.819,0,0,1,38.023,28.507Zm0,0",
                transform: "translate(12.161 636)"
              }
            }),
            h("path", {
              attrs: {
                d: "M14.562,19.981A1.078,1.078,0,1,1,13.484,18.9,1.078,1.078,0,0,1,14.562,19.981Zm0,0",
                transform: "translate(17.478 644.102)"
              }
            }),
            h("path", {
              attrs: {
                d: "M22.807,19.981A1.078,1.078,0,1,1,21.729,18.9,1.078,1.078,0,0,1,22.807,19.981Zm0,0",
                transform: "translate(21.012 644.102)"
              }
            }),
            h("path", {
              attrs: {
                d: "M16.353,29.54c0-.837-.4-1.516-.887-1.516s-.887.679-.887,1.516.4,1.516.887,1.516S16.353,30.377,16.353,29.54Zm0,0",
                transform: "translate(18.409 648.01)"
              }
            }),
            h("path", {
              attrs: {
                d: "M20.519,29.54c0-.837-.4-1.516-.887-1.516s-.887.679-.887,1.516.4,1.516.887,1.516S20.519,30.377,20.519,29.54Zm0,0",
                transform: "translate(20.195 648.01)"
              }
            }),
          ]),
        ])
      ],
    );
  }
};
var CafeIcon = {
  name: 'CafeIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -480)"}}, [
          h("g", {attrs: {transform: "translate(116.761 485)"}}, [
            h("g", {attrs: {transform: "translate(8.239)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("path", {
                  attrs: {
                    d: "M241.969,25.605c-.209-1.556,1.184-4.516,1.738-5.526a.715.715,0,0,0-.173-.9.809.809,0,0,0-.956-.058c-.151.1-3.713,2.449-4.528,5.875a7.777,7.777,0,0,0,.61,5.549,6.548,6.548,0,0,1,.667,4.138c-.644,3.938-2.2,5.21-2.21,5.216a.716.716,0,0,0-.185.968.788.788,0,0,0,.665.355.814.814,0,0,0,.323-.067c.2-.089,4.991-2.216,5.927-6.41a8.258,8.258,0,0,0-.789-5.53A13.7,13.7,0,0,1,241.969,25.605Zm.355,8.836a6.864,6.864,0,0,1-2.252,3.518,15.7,15.7,0,0,0,.792-3.045,7.919,7.919,0,0,0-.764-4.925,6.337,6.337,0,0,1-.532-4.662,6.794,6.794,0,0,1,1.287-2.534,7.311,7.311,0,0,0-.43,3,15.075,15.075,0,0,0,1.184,3.968A6.925,6.925,0,0,1,242.324,34.442Z",
                    transform: "translate(-201.243 -16.184)",
                  }
                }),
                h("path", {
                  attrs: {
                    d: "M76.509,139.657a18.106,18.106,0,0,1-3-3.816c-1-1.78-.748-5.894-.568-7.329a.738.738,0,0,0-.5-.78.8.8,0,0,0-.915.269c-.13.177-3.166,4.383-2.53,8.675a9.777,9.777,0,0,0,3.26,6.15,8.653,8.653,0,0,1,2.767,4.661c1.108,4.983-.168,7.177-.177,7.191a.717.717,0,0,0,.188.967.808.808,0,0,0,1.032-.064c.194-.187,4.749-4.644,3.9-9.867C79.5,142.783,78.045,141.265,76.509,139.657Zm.519,12.183a18.052,18.052,0,0,0-.474-4.66,9.993,9.993,0,0,0-3.151-5.365,8.445,8.445,0,0,1-2.857-5.347,9.271,9.271,0,0,1,.68-4.617,10.7,10.7,0,0,0,.915,4.686,19.593,19.593,0,0,0,3.217,4.115c1.493,1.562,2.672,2.8,3.077,5.286A8.963,8.963,0,0,1,77.028,151.84Z",
                    transform: "translate(-59.473 -108.781)",
                  }
                }),
                h("path", {
                  attrs: {
                    d: "M205.483,5.9A9.8,9.8,0,0,0,198.711.2,9.1,9.1,0,0,0,196.8,0c-5.464,0-10.57,4.788-12.138,11.386a15.515,15.515,0,0,0,.848,10.146,9.8,9.8,0,0,0,6.772,5.7,9.1,9.1,0,0,0,1.91.2h0c5.464,0,10.569-4.788,12.138-11.386A15.515,15.515,0,0,0,205.483,5.9Zm-.67,9.82a15,15,0,0,1-4.167,7.416,9.575,9.575,0,0,1-6.453,2.816h0a7.462,7.462,0,0,1-1.567-.166,8.3,8.3,0,0,1-5.695-4.86,14.1,14.1,0,0,1-.751-9.215A15,15,0,0,1,190.347,4.3,9.575,9.575,0,0,1,196.8,1.48a7.462,7.462,0,0,1,1.567.166,8.3,8.3,0,0,1,5.695,4.86A14.1,14.1,0,0,1,204.813,15.722Z",
                    transform: "translate(-156.804 0)",
                  }
                }),
                h("path", {
                  attrs: {
                    d: "M21.04,106.356a11.217,11.217,0,0,0-1.486.1c-7.5,1.006-12.473,9.464-11.081,18.853,1.293,8.724,7.588,15.3,14.643,15.3a11.229,11.229,0,0,0,1.486-.1,12.236,12.236,0,0,0,8.941-6.366,19.346,19.346,0,0,0,2.14-12.487C34.39,112.935,28.095,106.356,21.04,106.356Zm11.139,27.076a10.721,10.721,0,0,1-7.795,5.614,9.572,9.572,0,0,1-1.269.085,11.683,11.683,0,0,1-8.358-3.934A18.65,18.65,0,0,1,10.014,125.1c-1.272-8.581,3.105-16.288,9.757-17.18a9.572,9.572,0,0,1,1.269-.085A11.682,11.682,0,0,1,29.4,111.77a18.649,18.649,0,0,1,4.744,10.095A17.922,17.922,0,0,1,32.179,133.432Z",
                    transform: "translate(-8.239 -90.611)",
                  }
                }),
              ]),
            ]),
          ]),
        ])
      ],
    );
  }
};
var ChicagoIcon = {
  name: 'ChicagoIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -1020)"}}, [
          h("g", {attrs: {transform: "translate(125 1025.004)"}}, [
            h("path", {
              attrs: {
                d: "M86.977,175.421h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.979H86.977a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.979Z",
                transform: "translate(-77.602 -155.207)",
              }
            }),
            h("path", {
              attrs: {
                d: "M86.977,235.417h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.975H86.977a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,86.977,235.417Z",
                transform: "translate(-77.602 -209.343)",
              }
            }),
            h("path", {
              attrs: {
                d: "M86.977,295.419h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977H86.977a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.977Z",
                transform: "translate(-77.602 -263.486)",
              }
            }),
            h("path", {
              attrs: {
                d: "M86.977,355.415h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.973H86.977a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,86.977,355.415Z",
                transform: "translate(-77.602 -317.622)",
              }
            }),
            h("path", {
              attrs: {
                d: "M139.477,175.42h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,139.477,175.42Z",
                transform: "translate(-124.975 -155.206)",
              }
            }),
            h("path", {
              attrs: {
                d: "M139.477,235.418h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,139.477,235.418Z",
                transform: "translate(-124.975 -209.344)",
              }
            }),
            h("path", {
              attrs: {
                d: "M139.477,295.419h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,139.477,295.419Z",
                transform: "translate(-124.975 -263.486)",
              }
            }),
            h("path", {
              attrs: {
                d: "M139.477,355.417h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,139.477,355.417Z",
                transform: "translate(-124.975 -317.624)",
              }
            }),
            h("path", {
              attrs: {
                d: "M191.978,175.42h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,191.978,175.42Z",
                transform: "translate(-172.349 -155.206)",
              }
            }),
            h("path", {
              attrs: {
                d: "M191.978,235.418h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,191.978,235.418Z",
                transform: "translate(-172.349 -209.344)",
              }
            }),
            h("path", {
              attrs: {
                d: "M191.978,295.419h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,191.978,295.419Z",
                transform: "translate(-172.349 -263.486)",
              }
            }),
            h("path", {
              attrs: {
                d: "M191.978,355.417h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,191.978,355.417Z",
                transform: "translate(-172.349 -317.624)",
              }
            }),
            h("path", {
              attrs: {
                d: "M286.977,175.42h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.977Z",
                transform: "translate(-258.071 -155.206)",
              }
            }),
            h("path", {
              attrs: {
                d: "M286.977,115.423h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.977Z",
                transform: "translate(-258.071 -101.067)",
              }
            }),
            h("path", {
              attrs: {
                d: "M286.977,55.423h1.465a.977.977,0,0,0,.977-.977V52.981a.977.977,0,0,0-.977-.981h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.981Z",
                transform: "translate(-258.071 -46.926)",
              }
            }),
            h("path", {
              attrs: {
                d: "M286.977,235.418h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.977Z",
                transform: "translate(-258.071 -209.344)",
              }
            }),
            h("path", {
              attrs: {
                d: "M286.977,295.419h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.977Z",
                transform: "translate(-258.071 -263.486)",
              }
            }),
            h("path", {
              attrs: {
                d: "M286.977,355.417h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.977Z",
                transform: "translate(-258.071 -317.624)",
              }
            }),
            h("path", {
              attrs: {
                d: "M339.477,175.42h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,339.477,175.42Z",
                transform: "translate(-305.444 -155.206)",
              }
            }),
            h("path", {
              attrs: {
                d: "M339.477,115.423h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.977Z",
                transform: "translate(-305.444 -101.067)",
              }
            }),
            h("path", {
              attrs: {
                d: "M339.477,55.423h1.465a.977.977,0,0,0,.977-.977V52.981a.977.977,0,0,0-.977-.981h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.981Z",
                transform: "translate(-305.444 -46.926)",
              }
            }),
            h("path", {
              attrs: {
                d: "M339.477,235.418h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,339.477,235.418Z",
                transform: "translate(-305.444 -209.344)",
              }
            }),
            h("path", {
              attrs: {
                d: "M339.477,295.419h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,339.477,295.419Z",
                transform: "translate(-305.444 -263.486)",
              }
            }),
            h("path", {
              attrs: {
                d: "M339.477,355.417h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,339.477,355.417Z",
                transform: "translate(-305.444 -317.624)",
              }
            }),
            h("path", {
              attrs: {
                d: "M391.977,175.42h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,391.977,175.42Z",
                transform: "translate(-352.817 -155.206)",
              }
            }),
            h("path", {
              attrs: {
                d: "M391.977,115.423h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.977Z",
                transform: "translate(-352.817 -101.067)",
              }
            }),
            h("path", {
              attrs: {
                d: "M391.977,55.423h1.465a.977.977,0,0,0,.977-.977V52.981a.977.977,0,0,0-.977-.981h-1.465a.977.977,0,0,0-.977.977v1.465a.977.977,0,0,0,.977.981Z",
                transform: "translate(-352.817 -46.926)",
              }
            }),
            h("path", {
              attrs: {
                d: "M391.977,235.418h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,391.977,235.418Z",
                transform: "translate(-352.817 -209.344)",
              }
            }),
            h("path", {
              attrs: {
                d: "M391.977,295.419h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,391.977,295.419Z",
                transform: "translate(-352.817 -263.486)",
              }
            }),
            h("path", {
              attrs: {
                d: "M391.977,355.417h1.465a.977.977,0,0,0,.977-.977v-1.465a.977.977,0,0,0-.977-.977h-1.465a.977.977,0,0,0-.977.977v1.465A.977.977,0,0,0,391.977,355.417Z",
                transform: "translate(-352.817 -317.624)",
              }
            }),
            h("path", {
              attrs: {
                d: "M106.741,452a.977.977,0,1,0,0,1.954h.023a.977.977,0,1,0,0-1.954Z",
                transform: "translate(-95.435 -407.864)",
              }
            }),
            h("path", {
              attrs: {
                d: "M306.741,452a.977.977,0,1,0,0,1.954h.023a.977.977,0,0,0,0-1.954Z",
                transform: "translate(-275.904 -407.864)",
              }
            }),
            h("path", {
              attrs: {
                d: "M1,492H.977a.977.977,0,1,0,0,1.954H1A.977.977,0,1,0,1,492Z",
                transform: "translate(0 -443.955)",
              }
            }),
            h("path", {
              attrs: {
                d: "M492.764,492h-.023a.977.977,0,1,0,0,1.954h.023a.977.977,0,1,0,0-1.954Z",
                transform: "translate(-443.741 -443.955)",
              }
            }),
            h("path", {
              attrs: {
                d: "M72.332,48.048h-.687V.979A.977.977,0,0,0,70.669,0H51.146a.977.977,0,0,0-.977.977V12.885H31.607a.977.977,0,0,0-.977.977V48.048h-.687a.977.977,0,0,0,0,1.954H72.332a.977.977,0,0,0,0-1.954Zm-26.077,0H42.35V44.142h3.906Zm3.906,0H48.209V43.165a.977.977,0,0,0-.977-.977h-5.86a.977.977,0,0,0-.977.977v4.883H32.584V46.1h2.054a.977.977,0,1,0,0-1.954H32.584v-29.3H50.163Zm15.625,0H61.88V44.142h3.906Zm3.906,0H67.74V43.165a.977.977,0,0,0-.977-.977H60.9a.977.977,0,0,0-.977.977v4.883H52.107V46.1h2.054a.977.977,0,0,0,0-1.954H52.107V1.956H69.684Z",
                transform: "translate(-26.138 -0.001)",
              }
            }),
          ]),
        ])
      ],
    );
  }
};
var FareloIcon = {
  name: 'FareloIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -840)"}}, [
          h("g", {attrs: {transform: "translate(128.972 845)"}}, [
            h("g", {attrs: {transform: "translate(0.028 0)"}}, [
              h("path", {
                attrs: {
                  d: "M8.473,47.75a62.1,62.1,0,0,0,12.338,1.417A62.1,62.1,0,0,0,33.15,47.75,10.4,10.4,0,0,0,39.315,50,2.185,2.185,0,0,0,41.4,48.356a8.015,8.015,0,0,0-2.173-7.394A102.905,102.905,0,0,0,40.811,25,102.9,102.9,0,0,0,39.234,9.038a8.012,8.012,0,0,0,2.173-7.394A2.185,2.185,0,0,0,39.319,0a10.4,10.4,0,0,0-6.167,2.25A62.1,62.1,0,0,0,20.811.833,62.1,62.1,0,0,0,8.473,2.25,10.4,10.4,0,0,0,2.3,0,2.185,2.185,0,0,0,.213,1.644,8.015,8.015,0,0,0,2.388,9.038,102.905,102.905,0,0,0,.811,25,102.9,102.9,0,0,0,2.388,40.962,8.015,8.015,0,0,0,.213,48.356,2.185,2.185,0,0,0,2.3,50a10.4,10.4,0,0,0,6.169-2.25Zm-6.683.063a6.394,6.394,0,0,1,.975-4.706c.052.283.1.554.15.81a.834.834,0,0,0,1.638-.31A110.63,110.63,0,0,1,2.475,25,110.632,110.632,0,0,1,4.553,6.388a.833.833,0,1,0-1.638-.306c-.048.256-.1.527-.15.81a6.394,6.394,0,0,1-.975-4.7c.177-.521.4-.521.512-.521A9.075,9.075,0,0,1,6.263,2.75l-.25.062a.833.833,0,1,0,.4,1.617,63.735,63.735,0,0,1,14.4-1.923,63.734,63.734,0,0,1,14.4,1.923.833.833,0,1,0,.4-1.617l-.25-.062a9.075,9.075,0,0,1,3.962-1.081c.108,0,.333,0,.513.519a6.394,6.394,0,0,1-.975,4.706c-.052-.283-.1-.554-.15-.81a.833.833,0,0,0-1.637.31A110.631,110.631,0,0,1,39.144,25a110.63,110.63,0,0,1-2.075,18.612.833.833,0,0,0,1.637.31c.048-.256.1-.527.15-.81a6.394,6.394,0,0,1,.975,4.706c-.177.519-.4.519-.513.519a9.075,9.075,0,0,1-3.962-1.083l.25-.062a.833.833,0,1,0-.4-1.617,63.735,63.735,0,0,1-14.4,1.923,63.735,63.735,0,0,1-14.4-1.923.833.833,0,1,0-.4,1.617l.25.062A9.075,9.075,0,0,1,2.3,48.335c-.108,0-.335,0-.512-.519Z",
                  transform: "translate(-0.028 0)",
                }
              }),
              h("path", {
                attrs: {
                  d: "M7.879,12.121A42.954,42.954,0,0,1,21.961,9.669a42.954,42.954,0,0,1,14.083,2.452A.833.833,0,0,0,36.6,10.55a43.508,43.508,0,0,0-29.271,0,.833.833,0,0,0,.556,1.571Z",
                  transform: "translate(-1.178 3.665)",
                }
              }),
              h("path", {
                attrs: {
                  d: "M7.325,48.619a43.317,43.317,0,0,0,29.271,0,.833.833,0,1,0-.556-1.571A42.954,42.954,0,0,1,21.961,49.5,42.954,42.954,0,0,1,7.878,47.048a.833.833,0,1,0-.556,1.571Z",
                  transform: "translate(-1.178 -12.833)",
                }
              }),
            ]),
          ]),
        ]),
      ],
    );
  }
};
var FeijaoIcon = {
  name: 'FeijaoIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -540)"}}, [
          h("g", {attrs: {transform: "translate(125 494.605)"}}, [

            h("g", {attrs: {transform: "translate(17.069 61.388)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M181.4,117.149A1,1,0,0,0,180,117a2.873,2.873,0,0,1-3.592,0,1,1,0,0,0-1.247,1.553,4.865,4.865,0,0,0,6.085,0A1,1,0,0,0,181.4,117.149Z",
                    transform: "translate(-174.788 -116.776)"
                  }
                }),
              ]),
            ]),

            h("g", {attrs: {transform: "translate(0 55.394)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M49.28,75.814a11.74,11.74,0,0,0-4.018-5.447A11.274,11.274,0,0,0,40.9,68.394a12.007,12.007,0,0,0-2.675-8.857,11.377,11.377,0,0,0-8.933-4.143h-.58a11.1,11.1,0,0,0-6.979,2.552,1.994,1.994,0,0,1-2.493,0,11.1,11.1,0,0,0-6.979-2.552h-.58a11.519,11.519,0,0,0-6.94,2.247A11.9,11.9,0,0,0,.314,69.809a11.454,11.454,0,0,0,3.87,6.139,25.5,25.5,0,0,0,4.869,3.2,11.331,11.331,0,0,0,4.162,9.53,25.462,25.462,0,0,0,32.6,0,11.453,11.453,0,0,0,3.87-6.139A11.684,11.684,0,0,0,49.28,75.814ZM9.372,77.062a23.525,23.525,0,0,1-3.911-2.643A9.414,9.414,0,0,1,2.592,63.767a9.475,9.475,0,0,1,9.086-6.381h.58A9.13,9.13,0,0,1,17.991,59.5a3.986,3.986,0,0,0,4.987,0,9.129,9.129,0,0,1,5.733-2.114h.58a9.418,9.418,0,0,1,7.4,3.421,9.993,9.993,0,0,1,2.235,7.329c-.2-.01-.4-.016-.6-.016h-.58a11.1,11.1,0,0,0-6.979,2.552,1.995,1.995,0,0,1-2.493,0,11.1,11.1,0,0,0-6.979-2.552h-.58a11.519,11.519,0,0,0-6.94,2.247,11.739,11.739,0,0,0-4.018,5.447A12.131,12.131,0,0,0,9.372,77.062ZM44.539,87.144a23.47,23.47,0,0,1-30.047,0,9.648,9.648,0,0,1,6.217-17.033h.58a9.13,9.13,0,0,1,5.733,2.114,3.986,3.986,0,0,0,4.987,0,9.13,9.13,0,0,1,5.733-2.114h.58a9.648,9.648,0,0,1,6.217,17.033Z",
                    transform: "translate(0 -55.394)"
                  }
                }),
              ]),
            ]),

            h("g", {attrs: {transform: "translate(25.941 73.979)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M272.254,246.076a1,1,0,0,0-1.4-.153,2.873,2.873,0,0,1-3.592,0,1,1,0,0,0-1.247,1.553,4.864,4.864,0,0,0,6.085,0A1,1,0,0,0,272.254,246.076Z",
                    transform: "translate(-265.642 -245.703)"
                  }
                }),
              ]),
            ]),

            h("g", {attrs: {transform: "translate(28.519 87.034)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M303.763,379.928a1,1,0,0,0-1.341-.432,20.369,20.369,0,0,1-9.385,2.258,1,1,0,0,0,0,1.992,22.342,22.342,0,0,0,10.294-2.477A1,1,0,0,0,303.763,379.928Z",
                    transform: "translate(-292.041 -379.386)"
                  }
                }),
              ]),
            ]),

            h("g", {attrs: {transform: "translate(41.601 84.398)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M428.5,352.751a1,1,0,0,0-1.4-.127c-.231.192-.468.382-.707.564a1,1,0,1,0,1.208,1.584c.261-.2.522-.407.775-.618A1,1,0,0,0,428.5,352.751Z",
                    transform: "translate(-425.994 -352.393)"
                  }
                }),
              ]),
            ]),

          ]),
        ]),
      ],
    );
  }
};
var FrangoIcon = {
  name: 'FrangoIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": ""
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -660)"}}, [
          h("g", {attrs: {transform: "translate(125 665)"}}, [

            h("g", {attrs: {transform: "translate(42.5 9.166)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("path", {
                  attrs: {
                    d: "M.377,94a.831.831,0,0,1,.787-.07L7,96.433a.833.833,0,0,1,0,1.532l-5.833,2.5A.833.833,0,0,1,0,99.7v-5A.833.833,0,0,1,.377,94Zm1.292,4.432L4.553,97.2,1.669,95.962Z",
                    transform: "translate(-0.002 -93.865)"
                  }
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(29.167 0)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("path", {
                  attrs: {
                    d: "M103.234,0H107.4a5.84,5.84,0,0,1,5.833,5.833.834.834,0,0,1-.833.833h-4.167A5.84,5.84,0,0,1,102.4.834.834.834,0,0,1,103.234,0Zm5,5h3.249A4.174,4.174,0,0,0,107.4,1.668h-3.249A4.173,4.173,0,0,0,108.234,5Z",
                    transform: "translate(-102.401 -0.001)"
                  }
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(35 9.167)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("path", {
                  attrs: {
                    d: "M104.9,93.867a2.5,2.5,0,1,1-2.5,2.5A2.5,2.5,0,0,1,104.9,93.867Zm0,3.333a.833.833,0,1,0-.833-.833A.835.835,0,0,0,104.9,97.2Z",
                    transform: "translate(-102.401 -93.867)"
                  }
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(26.667 42.5)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("rect", {
                  attrs: {width: "1.667", height: "6.667"}
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(18.333 48.333)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("rect", {
                  attrs: {width: "13.333", height: "1.667"}
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(21.667 42.5)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("rect", {
                  attrs: {width: "1.667", height: "6.667"}
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(25 45)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("rect", {
                  attrs: {width: "2.5", height: "1.667"}
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(20 45)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("rect", {
                  attrs: {width: "2.5", height: "1.667"}
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(42.5 14.167)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("path", {
                  attrs: {
                    d: "M.416,145.181a.832.832,0,0,1,.833,0l4.369,2.5A3.788,3.788,0,0,1,7.5,150.9v.385a3.75,3.75,0,0,1-3.725,3.782H3.751A3.753,3.753,0,0,1,0,151.318V145.9A.835.835,0,0,1,.416,145.181Zm1.252,6.137A2.085,2.085,0,0,0,3.751,153.4v.833l.017-.833a2.083,2.083,0,0,0,2.066-2.107v-.381a2.109,2.109,0,0,0-1.047-1.788l-3.119-1.786Z",
                    transform: "translate(-0.001 -145.068)"
                  }
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(0 4.987)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("path", {
                  attrs: {
                    d: "M59.735,51.917v-.833h7.5A15.421,15.421,0,0,1,81.1,59.833l3.64,7.645,5.816-12.207A7.2,7.2,0,0,1,96.5,51.085a6.966,6.966,0,0,1,7.388,6.516c.01.149.014.3.014.449V70.668a18.784,18.784,0,0,1-18.75,18.749c-10.043,0-18.2-8.952-18.723-16.71a7.51,7.51,0,0,1-6.693-7.457v-.833h2.791a7.49,7.49,0,0,1-2.791-5.833V57.75h2.791A7.491,7.491,0,0,1,59.735,51.917Zm1.726,7.5a5.842,5.842,0,0,0,5.774,5v1.667H61.461a5.842,5.842,0,0,0,5.774,5h.833v.833c0,7.128,7.883,15.833,17.083,15.833a17.115,17.115,0,0,0,17.083-17.083V58.05c0-.114,0-.228-.011-.343a5.3,5.3,0,0,0-5.272-4.97q-.164,0-.33.01a5.53,5.53,0,0,0-4.56,3.228L84.734,71.354,79.59,60.55a13.745,13.745,0,0,0-12.353-7.8H61.461a5.842,5.842,0,0,0,5.774,5v1.667H61.461Z",
                    transform: "translate(-59.735 -51.071)"
                  }
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(10.708 25)"}}, [
              h("g", {attrs: {transform: "translate(0)"}}, [
                h("path", {
                  attrs: {
                    d: "M139.792,256v1.667H130a5.984,5.984,0,0,0,5.67,4.167l.016,1.667h-2.352a5.983,5.983,0,0,0,5.678,4.167h3.283a10.846,10.846,0,0,0,10.833-10.833V256h1.667v.833a12.514,12.514,0,0,1-12.5,12.5h-3.283a7.651,7.651,0,0,1-7.542-6.55l-.087-.622a7.628,7.628,0,0,1-3.246-5.211L128,256h11.792Z",
                    transform: "translate(-128 -256.001)"
                  }
                }),
              ]),
            ]),

          ]),
        ])
      ]);
  }
};
var MilhoIcon = {
  name: 'MilhoIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -720)"}}, [
          h("g", {attrs: {transform: "translate(125 724.998)"}}, [

            h("g", {attrs: {transform: "translate(0 0.001)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M48.226,1.776C46.81.359,43.973-.937,38.5.93c-4.4,1.5-9.7,4.754-15.751,9.673a3.965,3.965,0,0,0-1.716-1.925.977.977,0,0,0-1.151.171c-2.776,2.776-5.648,5.273-8.181,7.476C5.275,21.91.2,26.322.006,31.926c-.128,3.684,1.855,7.442,6.241,11.828C10.508,48.016,14.163,50,17.748,50h0c5.757,0,10.246-5.162,15.929-11.7,2.2-2.533,4.7-5.4,7.476-8.181a.977.977,0,0,0,.171-1.151,3.959,3.959,0,0,0-1.922-1.72c4.917-6.051,8.169-11.344,9.67-15.748C50.938,6.029,49.642,3.192,48.226,1.776ZM32.769,24.6l2.026,2.026a23.843,23.843,0,0,0-4.747.833Q31.459,25.988,32.769,24.6Zm-4.414,1.8-4.75-4.75q1.638-1.578,3.183-3.032l4.6,4.6Q29.934,24.758,28.355,26.4Zm4.367-4.61L28.216,17.28q1.683-1.563,3.247-2.967l4.226,4.226Q34.286,20.1,32.722,21.786Zm.2-8.773q1.756-1.546,3.344-2.87l3.59,3.59q-1.323,1.588-2.87,3.344ZM37.787,8.9q1.026-.827,1.972-1.55c.556-.425,1.07-.8,1.546-1.146L43.8,8.7c-.342.477-.722.99-1.146,1.546q-.721.945-1.55,1.972Zm5.155-3.821c2.467-1.61,3.5-1.845,3.848-1.865-.02.349-.255,1.381-1.865,3.848Zm1.375-3.056a25.113,25.113,0,0,0-2.784,1.646L40.291,2.425A10.471,10.471,0,0,1,44.317,2.021Zm-6.1,1.092,1.69,1.69c-.163.118-.327.238-.494.362Q38,6.21,36.4,7.508L34.014,5.125A33.685,33.685,0,0,1,38.216,3.113ZM32.273,6.146l2.609,2.609q-1.588,1.327-3.341,2.873l-3-3Q30.513,7.223,32.273,6.146ZM26.947,9.8l3.133,3.133q-1.564,1.405-3.246,2.968L23.47,12.534Q25.28,11.045,26.947,9.8Zm-3.568,5.409,2.027,2.027q-1.4,1.314-2.867,2.729A23.9,23.9,0,0,0,23.379,15.206Zm-1.177,7.8L27,27.8q-.5.511-1.006,1.03-1.412.568-2.894,1.284L19.883,26.9q.2-.416.383-.808.482-1.044.893-2.069Q21.685,23.508,22.2,23.005Zm-.935,8.042a58.409,58.409,0,0,0-6.087,3.772,58.638,58.638,0,0,0,3.77-6.09Zm-16.71,7.8a32.877,32.877,0,0,0,3.482-5.444.977.977,0,1,0-1.747-.874,30.8,30.8,0,0,1-2.866,4.588,9.66,9.66,0,0,1-1.469-5.125c.166-4.755,4.957-8.922,11.022-14.2,2.369-2.06,5.03-4.374,7.654-6.949a3.857,3.857,0,0,1,.661,1.6l0,.021c.024.12.044.238.061.351a17.812,17.812,0,0,1-.92,7.448.973.973,0,0,0-.1.335q-.361,1.141-.838,2.351a.97.97,0,0,0-.125.311A59.173,59.173,0,0,1,6.941,41.67,28.687,28.687,0,0,1,4.557,38.849ZM32.2,37.022c-5.357,6.161-9.588,11.027-14.456,11.026a10.231,10.231,0,0,1-5.35-1.76,30.805,30.805,0,0,1,4.624-2.893.977.977,0,0,0-.874-1.747,32.873,32.873,0,0,0-5.43,3.471,30,30,0,0,1-2.385-2.058A61.59,61.59,0,0,1,23.438,32.129C28,29.85,32.491,28.544,35.754,28.544a5.663,5.663,0,0,1,3.4.825C36.577,31.992,34.263,34.653,32.2,37.022Zm5.264-10.49L34.1,23.168q1.563-1.682,2.968-3.246L40.2,23.054Q38.953,24.723,37.468,26.532Zm3.9-5.072-3-3q1.545-1.752,2.873-3.341l2.609,2.609Q42.775,19.489,41.372,21.46Zm3.5-5.472L42.493,13.6q1.3-1.6,2.344-3.015c.124-.167.244-.331.362-.494l1.69,1.69A33.691,33.691,0,0,1,44.877,15.987Zm2.7-6.277L46.334,8.468a25.119,25.119,0,0,0,1.646-2.784A10.468,10.468,0,0,1,47.577,9.711Z",
                    transform: "translate(0 -0.001)"
                  }
                }),
              ]),
            ]),

            h("g", {attrs: {transform: "translate(7.298 29.432)"}}, [
              h("path", {
                attrs: {
                  d: "M76.015,301.419a.982.982,0,1,0,.613,1.25l.007-.019A.973.973,0,0,0,76.015,301.419Z",
                  transform: "translate(-74.727 -301.369)"
                }
              }),
            ]),
            h("g", {attrs: {transform: "translate(18.174 40.41)"}}, [
              h("path", {
                attrs: {
                  d: "M187.388,413.838a.982.982,0,1,0,.613,1.25l.007-.019A.973.973,0,0,0,187.388,413.838Z",
                  transform: "translate(-186.1 -413.788)"
                }
              }),
            ]),
            h("g", {attrs: {transform: "translate(18.805 40.488)"}}, [
              h("path", {
                attrs: {d: "M192.564,414.584h0l.014-.006Z", transform: "translate(-192.564 -414.579)"}
              }),
            ]),

          ]),
        ])


      ],
    );
  }
};
var SojaIcon = {
  name: 'SojaIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),

      [
        h("g", {attrs: {transform: "translate(-120 -780)"}}, [
          h("g", {attrs: {transform: "translate(125 785)"}}, [
            h("path", {
              attrs: {
                d: "M9.238,21.425a13.926,13.926,0,0,0-.1,1.691,13.762,13.762,0,0,0,.1,1.691l1.581-.2a12.256,12.256,0,0,1,0-2.992Z",
                transform: "translate(3.612 9.182)"
              }
            }),
            h("path", {
              attrs: {
                d: "M40.114,30.575a4.133,4.133,0,0,0-1.314.214l-.362.12a9.059,9.059,0,0,1-5.009.2c.025-.01.049-.017.074-.027l1.156-.5a4.173,4.173,0,0,0-3.029-7.765l-.362.12a9.056,9.056,0,0,1-5.707,0l-.351-.116a4.24,4.24,0,0,0-3.223,7.818l.216.108c.3.151.613.287.927.415a9.049,9.049,0,0,1-4.739-.257l-.35-.116a4.24,4.24,0,0,0-3.224,7.817l.216.108a13.434,13.434,0,0,0,11.3.332l1.156-.5a4.113,4.113,0,0,0,.848-.492,4.278,4.278,0,0,0,.821.548l.216.108a13.436,13.436,0,0,0,11.3.332l1.156-.5a4.158,4.158,0,0,0-1.714-7.979ZM22.7,29.217a2.645,2.645,0,0,1,2.007-4.88l.351.116a10.665,10.665,0,0,0,6.713,0l.362-.12a2.714,2.714,0,0,1,.888-.131,2.564,2.564,0,0,1,1.009,4.921l-1.156.5a11.973,11.973,0,0,1-9.96-.294Zm3.006,8.368a11.973,11.973,0,0,1-9.96-.294l-.216-.108a2.645,2.645,0,0,1,2.008-4.88l.35.116a10.665,10.665,0,0,0,6.713,0l.362-.12a2.692,2.692,0,0,1,.888-.132,2.554,2.554,0,0,1,1.558.529,4.169,4.169,0,0,0-.08,4.127,2.614,2.614,0,0,1-.468.265Zm15.5-.5-1.156.5a11.973,11.973,0,0,1-9.96-.294l-.216-.108a2.645,2.645,0,0,1,2.008-4.88l.351.116a10.665,10.665,0,0,0,6.713,0l.362-.12a2.714,2.714,0,0,1,.888-.131A2.564,2.564,0,0,1,41.2,37.09Z",
                transform: "translate(5.046 9.689)"
              }
            }),
            h("path", {
              attrs: {
                d: "M27.666,30.909l-.2,1.581a13.757,13.757,0,0,0,3.383,0l-.2-1.581A12.356,12.356,0,0,1,27.666,30.909Z",
                transform: "translate(11.47 13.247)"
              }
            }),
            h("path", {
              attrs: {
                d: "M25.833,26.913l-.2-1.581a12.356,12.356,0,0,1-2.991,0l-.2,1.581a13.757,13.757,0,0,0,3.383,0Z",
                transform: "translate(9.319 10.857)"
              }
            }),
            h("path", {
              attrs: {
                d: "M17.627,30.909l-.2,1.581a13.757,13.757,0,0,0,3.383,0l-.2-1.581A12.357,12.357,0,0,1,17.627,30.909Z",
                transform: "translate(7.168 13.247)"
              }
            }),
            h("path", {
              attrs: {
                d: "M18.536,36.827a4.142,4.142,0,0,0-.214-1.315l-.12-.361a9.026,9.026,0,0,1,0-5.707l.117-.351a4.205,4.205,0,0,0-1.7-4.864l.039-.006a32.329,32.329,0,0,0-3.768-11.385A20.686,20.686,0,0,0,12.2,9.97L14.916,0,8.309,2.2,6.7,8.646l-.5.249A10.832,10.832,0,0,0,2.66,25.442a10.364,10.364,0,0,0,.745,14.172A9.76,9.76,0,0,0,11,49.026L15.219,50l.4-2.781c.317-2.219.578-4.473.782-6.706A4.209,4.209,0,0,0,18.536,36.827ZM13.157,17.141a30.693,30.693,0,0,1,1.784,6.46,4.294,4.294,0,0,0-.66-.066,4.211,4.211,0,0,0-2.164.6l.751-4.259A20.578,20.578,0,0,0,13.157,17.141ZM5.139,41.007l.983.7.927-1.3L5.494,39.3A8.793,8.793,0,0,1,3.76,26.616l.669.669,1.127-1.127L4.51,25.113a9.237,9.237,0,0,1,2.4-14.793l1.154-.578,1.576-6.3L12.6,2.454l-2.062,7.56.076.229a19.144,19.144,0,0,1,.689,9.351l-.94,5.328a38.6,38.6,0,0,0-.587,6.7v.536a38.737,38.737,0,0,0,3.372,15.731l-1.783-.412A8.17,8.17,0,0,1,5.139,41.007Zm9.006,5.166a37.21,37.21,0,0,1-1.812-5.66,4.141,4.141,0,0,0,2.046.55c.125,0,.242-.026.364-.037C14.578,42.741,14.378,44.463,14.144,46.173Zm2.546-10.518.12.36a2.717,2.717,0,0,1,.131.888,2.564,2.564,0,0,1-4.92,1.011l-.284-.664a36.634,36.634,0,0,1-.372-5.1v-.536a36.973,36.973,0,0,1,.269-4.39l.049-.118c.043-.105.084-.21.135-.311l.109-.217a2.645,2.645,0,0,1,4.88,2.008l-.117.351a10.614,10.614,0,0,0,0,6.714Z",
                transform: "translate(-0.212)"
              }
            }),
          ])
        ]),
      ],
    );
  }
};
var SuinoIcon = {
  name: 'SuinoIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -900)"}}, [
          h("g", {attrs: {transform: "translate(125 835.992)"}}, [

            h("g", {attrs: {transform: "translate(11.717 87.558)"}}, [
              h("path", {
                attrs: {
                  d: "M121.055,194.269a1.074,1.074,0,1,0,1.074,1.074A1.075,1.075,0,0,0,121.055,194.269Z",
                  transform: "translate(-119.981 -194.269)"
                }
              }),
            ]),
            h("g", {attrs: {transform: "translate(34.692 82.945)"}}, [
              h("path", {
                attrs: {
                  d: "M363.979,150.605a10.187,10.187,0,0,0-7.751-3.57.977.977,0,0,0,0,1.953,8.237,8.237,0,0,1,6.267,2.887.977.977,0,1,0,1.484-1.27Z",
                  transform: "translate(-355.251 -147.035)"
                }
              }),
            ]),
            h("g", {attrs: {transform: "translate(43.153 88.493)"}}, [
              h("path", {
                attrs: {
                  d: "M443.758,204.444l-.016-.035a.976.976,0,0,0-1.722-.08.956.956,0,0,0-.137.509.973.973,0,0,0,.084.385l0,.007a.981.981,0,0,0,1.3.505A.982.982,0,0,0,443.758,204.444Z",
                  transform: "translate(-441.883 -203.849)"
                }
              }),
            ]),
            h("g", {attrs: {transform: "translate(0 76.009)"}}, [
              h("path", {
                attrs: {
                  d: "M48.9,82.273a3.763,3.763,0,0,0,0-5.326,3.217,3.217,0,0,0-4.54,0,2.67,2.67,0,0,0-.118,3.752,2.221,2.221,0,0,0,2.57.418,1.746,1.746,0,0,0,.92-2.008A.977.977,0,0,0,45.8,79.4a.358.358,0,0,1-.125-.02.711.711,0,0,1,.061-1.047,1.261,1.261,0,0,1,1.78,0,1.81,1.81,0,0,1,0,2.562,2.511,2.511,0,0,1-2.259.689,11.384,11.384,0,0,0-6.72-2.186H24.183l-.061,0a18.3,18.3,0,0,1-8.827-1.9,6.544,6.544,0,0,0-4.089-1.314,4.46,4.46,0,0,0-4.119,3.131.976.976,0,0,0,.931,1.3h.05a3.562,3.562,0,0,1,1.67.4L7.653,83.746a14.258,14.258,0,0,1-5.062,4.146l-.629.307c-.467.094-1.1.461-1.533,1.662a9.654,9.654,0,0,0,0,5.689c.455,1.276,1.147,1.61,1.618,1.677l9.092,2.978a8.511,8.511,0,0,0,2.215.473l1.111.079.291,2.914-.625,3.59a10.06,10.06,0,0,0-1.457,2.544.977.977,0,0,0,.9,1.359h8.877a.976.976,0,0,0,.976-.954,13.818,13.818,0,0,1,2.009-6.4,23.424,23.424,0,0,0,4.157.369,26.055,26.055,0,0,0,4.811-.338v3.5a10.556,10.556,0,0,0-1.386,2.464.977.977,0,0,0,.9,1.359h9.321a.976.976,0,0,0,.969-.854c.349-2.763,1.6-10.353,3.182-12.261l.031-.039.575-.77.026-.037a11.4,11.4,0,0,0-.841-13.86A4.463,4.463,0,0,0,48.9,82.273ZM2.246,94.83a7.855,7.855,0,0,1,0-4.249,6.82,6.82,0,0,1,.293,2.125A6.82,6.82,0,0,1,2.246,94.83Zm19.3,14.381H20.3a28.1,28.1,0,0,1,1.483-6.4q.8.3,1.647.542A15.849,15.849,0,0,0,21.55,109.21Zm15.605,0H35.484a3.23,3.23,0,0,1,.44-.647.976.976,0,0,0,.432-.811v-4.433c.339-.119.678-.253,1.019-.405l.826,4.516A9.315,9.315,0,0,0,37.155,109.21Zm10.864-18.4a9.407,9.407,0,0,1-1.606,5.274l-.547.733c-1.918,2.348-3.11,9.742-3.484,12.388H39.356a3.178,3.178,0,0,1,.441-.647.976.976,0,0,0,.416-.987L38.75,99.582a.977.977,0,1,0-1.921.352l.182.994c-2.223,1.093-4.241,1.3-7.419,1.3a20.379,20.379,0,0,1-6.946-1.18q.147-.235.305-.449a.977.977,0,0,0-1.568-1.164c-2.066,2.783-2.821,7.739-3.053,9.779H15.141a3.177,3.177,0,0,1,.441-.647.977.977,0,0,0,.418-.643l.7-4.045a.983.983,0,0,0,.01-.264l-.386-3.866a.977.977,0,0,0-.9-.877l-1.932-.137a6.608,6.608,0,0,1-1.745-.38L3.966,95.8c.033-.079.066-.162.1-.25a8.762,8.762,0,0,0,.429-2.845,8.765,8.765,0,0,0-.429-2.845,4.41,4.41,0,0,0-.181-.434,16.227,16.227,0,0,0,5.323-4.5l1.981-2.6a6,6,0,0,1,.848,1.875.977.977,0,0,0,1.906-.426,8.1,8.1,0,0,0-1.135-2.532,5.67,5.67,0,0,0-3.216-2.39,2.49,2.49,0,0,1,1.707-.728,4.709,4.709,0,0,1,2.834.935.985.985,0,0,0,.1.069,6.066,6.066,0,0,1,1.889,2.329.977.977,0,0,0,1.771-.825l-.027-.056a19.333,19.333,0,0,0,5.349.791c.33,0,.666-.01,1.005-.03H38.536A9.487,9.487,0,0,1,48.02,90.815Z",
                  transform: "translate(0 -76.009)"
                }
              }),
            ]),
          ]),
        ])
      ],
    );
  }
};


var TrigoIcon = {
  name: 'TrigoIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -960)"}}, [
          // h("rect", {
          //   attrs: {width:"60",height:"60",transform:"translate(120 960)"}
          // }),
          h("path", {
            attrs: {
              d: "M-2224.344-20795.721h-.748v-10.039c-6.472-.6-6.184-9.02-6.184-9.02a10.193,10.193,0,0,1,6.921,8.836h.01v0h.01a10.184,10.184,0,0,1,6.916-8.836s.293,8.418-6.178,9.02v10.039Zm-27.722,0h-.748v-10.039c-6.477-.6-6.184-9.02-6.184-9.02a10.193,10.193,0,0,1,6.922,8.836h.01v0h.01a10.184,10.184,0,0,1,6.916-8.836s.293,8.418-6.178,9.02v10.039Zm13.859-5h-.748v-10.035c-6.471-.607-6.184-9.025-6.184-9.025a10.217,10.217,0,0,1,6.927,8.838h.005v0h.01a10.2,10.2,0,0,1,6.916-8.838s.3,8.418-6.174,9.025v10.035Zm6.932-22.639a10.174,10.174,0,0,1,6.932,9.057,10.164,10.164,0,0,1,6.927-9.057s.314,9.057-6.927,9.057S-2231.275-20823.359-2231.275-20823.359Zm-27.723,0a10.174,10.174,0,0,1,6.932,9.057,10.163,10.163,0,0,1,6.927-9.057s.314,9.057-6.927,9.057S-2259-20823.359-2259-20823.359Zm13.859-5a10.17,10.17,0,0,1,6.932,9.055,10.16,10.16,0,0,1,6.927-9.055s.319,9.055-6.927,9.055S-2245.139-20828.359-2245.139-20828.359Zm13.864-3.584a10.175,10.175,0,0,1,6.932,9.055,10.165,10.165,0,0,1,6.927-9.055s.314,9.055-6.927,9.055S-2231.275-20831.943-2231.275-20831.943Zm-27.723,0a10.175,10.175,0,0,1,6.932,9.055,10.165,10.165,0,0,1,6.927-9.055s.314,9.055-6.927,9.055S-2259-20831.943-2259-20831.943Zm13.859-5a10.177,10.177,0,0,1,6.932,9.057,10.167,10.167,0,0,1,6.927-9.057s.319,9.057-6.927,9.057S-2245.139-20836.945-2245.139-20836.945Zm20.8-4.055s6.294,6.617,0,12.363C-2230.648-20834.383-2224.344-20841-2224.344-20841Zm-27.722,0s6.294,6.617,0,12.363C-2258.37-20834.383-2252.066-20841-2252.066-20841Zm13.859-5s6.3,6.619,0,12.363C-2244.506-20839.383-2238.207-20846-2238.207-20846Z",
              transform: "translate(2388 21810.719)"
            }
          }),
        ])
      ],
    );
  }
};

var LatamIcon = {
  name: 'LatamIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "28",
          height: "28",
          viewBox: "0 0 28 28",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("path", {
          attrs: {
            d: "M13.8.05A13.794,13.794,0,0,0,1.119,8.415l-.172.057.067.2A13.793,13.793,0,1,0,13.8.05ZM24.622,20.8l-.708-.708V18.442a.459.459,0,0,0-.046-.206l-1.793-3.581V12.925a.46.46,0,0,0-.2-.383l-1.379-.92a.46.46,0,0,0-.368-.063l-1.689.422L15.6,10.764l-.39-2.735,1.082-1.081H18.61l.782,1.175a.46.46,0,0,0,.307.2l2.759.46a.456.456,0,0,0,.221-.017l2.541-.847A12.829,12.829,0,0,1,24.622,20.8Zm-1.9-16.218-.748.5-2.084-.417-1.352-.45a.452.452,0,0,0-.257-.01l-1.71.427-.749-.25.555-1.111h1.555a.46.46,0,0,0,.206-.048l1.591-.8A12.922,12.922,0,0,1,22.726,4.581ZM8.762,2l1.1.736a.459.459,0,0,0,.18.071l2.228.372-.217.651-1.161.388a.46.46,0,0,0-.249.2l-1.321,2.2L7.2,7.885l-3.127.446a.46.46,0,0,0-.4.455v1.379a.46.46,0,0,0,.135.325l.785.785v.79L2.689,10.79,2,8.709A12.949,12.949,0,0,1,8.762,2ZM6.07,24.141A12.871,12.871,0,0,1,1.485,10.085l.382,1.146a.46.46,0,0,0,.181.237L4.34,13l-.523.523a.46.46,0,0,0-.135.325v1.379a.46.46,0,0,0,.048.206l.92,1.839a.46.46,0,0,0,.322.245L6.9,17.9v4.222a.46.46,0,0,0,.033.171l.92,2.3a.46.46,0,0,0,.282.265l1.379.46a.452.452,0,0,0,.143.024.46.46,0,0,0,.46-.46V22.811l1.655-1.241a.46.46,0,0,0,.184-.368V20.012l1.7-1.7a.46.46,0,0,0,.126-.235l.46-2.3a.46.46,0,0,0-.451-.55H12.219l-1.246-2.076a.46.46,0,0,0-.394-.223H7.645l-.79-1.585a.46.46,0,0,0-.338-.248.451.451,0,0,0-.4.129l-.6.595v-.729a.46.46,0,0,0-.135-.325L4.6,9.975v-.79l2.824-.4A.462.462,0,0,0,7.6,8.721L9.9,7.341a.46.46,0,0,0,.157-.157l1.292-2.153,1.218-.406a.455.455,0,0,0,.291-.291l.46-1.379a.46.46,0,0,0-.36-.6l-2.661-.444L9.825,1.6a12.839,12.839,0,0,1,8.843.329l-.84.419H16.1a.46.46,0,0,0-.414.254l-.92,1.839a.46.46,0,0,0,.266.641l1.379.46a.452.452,0,0,0,.257.01l1.71-.427,1.253.417a.338.338,0,0,0,.055.015l2.3.46a.457.457,0,0,0,.345-.068l1.047-.7A12.972,12.972,0,0,1,24.757,7.1l-2.262.754-2.449-.408-.809-1.214a.46.46,0,0,0-.38-.2H16.1a.46.46,0,0,0-.325.135L14.392,7.542a.46.46,0,0,0-.13.39l.46,3.219a.46.46,0,0,0,.276.357l3.219,1.379a.454.454,0,0,0,.292.023l1.642-.411,1,.67v1.593a.459.459,0,0,0,.046.206l1.793,3.581v1.731a.46.46,0,0,0,.135.325l.962.962A12.871,12.871,0,0,1,6.07,24.141Z",
            transform: "translate(0 -0.05)"
          }
        }),
      ]
    );
  }
};

var SafrasTvIcon = {
  name: 'SafrasTvIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(-14 -297.167)"}}, [
        h("g", {attrs: {transform: "translate(-1977 -5155)"}}, [
          h("path", {
            attrs: {
              d: "M 2009.05615234375 5471.81591796875 L 1992.99560546875 5470.18359375 L 1992.977905273438 5470.181640625 L 1992.960205078125 5470.181640625 C 1992.072631835938 5470.181640625 1991.350463867188 5469.5107421875 1991.350463867188 5468.68603515625 L 1991.350463867188 5456.98828125 C 1991.350463867188 5456.16357421875 1992.072631835938 5455.49267578125 1992.960205078125 5455.49267578125 L 1992.992309570312 5455.49267578125 L 1993.02392578125 5455.48681640625 L 2009.069946289062 5452.5166015625 C 2009.944213867188 5452.5322265625 2010.650390625 5453.19677734375 2010.650390625 5454.01220703125 L 2010.650390625 5470.31884765625 C 2010.650390625 5471.13916015625 2009.936767578125 5471.8076171875 2009.05615234375 5471.81591796875 Z M 1994.016845703125 5470.13232421875 L 2007.635620117188 5471.5322265625 L 2007.653442382812 5471.5341796875 L 2007.67138671875 5471.5341796875 C 2008.780639648438 5471.5341796875 2009.68310546875 5470.66552734375 2009.68310546875 5469.59814453125 L 2009.68310546875 5455.59423828125 C 2009.68310546875 5454.52734375 2008.78076171875 5453.6591796875 2007.671508789062 5453.6591796875 L 2007.639038085938 5453.6591796875 L 2007.607055664062 5453.6650390625 L 1994.00146484375 5456.21533203125 C 1992.907104492188 5456.232421875 1992.0224609375 5457.09375 1992.0224609375 5458.14990234375 L 1992.0224609375 5468.19580078125 C 1992.0224609375 5469.25732421875 1992.915405273438 5470.12255859375 1994.016845703125 5470.13232421875 Z",
              stroke: "none"
            }
          }),
          h("path", {
            attrs: {
              d: "M 2009.071166992188 5471.4658203125 C 2009.751831054688 5471.4501953125 2010.300415039062 5470.94189453125 2010.300415039062 5470.31884765625 L 2010.300415039062 5454.01220703125 C 2010.300415039062 5453.39794921875 2009.765747070312 5452.8955078125 2009.09716796875 5452.86767578125 L 1993.087646484375 5455.8310546875 L 1993.0244140625 5455.8427734375 L 1992.960205078125 5455.8427734375 C 1992.265625 5455.8427734375 1991.700439453125 5456.3564453125 1991.700439453125 5456.98828125 L 1991.700439453125 5457.79736328125 C 1991.872680664062 5456.72607421875 1992.817504882812 5455.8984375 1993.965087890625 5455.86572265625 L 2007.542602539062 5453.3212890625 L 2007.67138671875 5454.0087890625 L 2007.671630859375 5453.30908203125 C 2008.973754882812 5453.3095703125 2010.033081054688 5454.33447265625 2010.033081054688 5455.59423828125 L 2010.033081054688 5469.59814453125 C 2010.033081054688 5470.36669921875 2009.639404296875 5471.04736328125 2009.037109375 5471.46240234375 L 2009.071166992188 5471.4658203125 M 1992.130859375 5469.5478515625 C 1991.9111328125 5469.2587890625 1991.759887695312 5468.91796875 1991.700439453125 5468.54833984375 L 1991.700439453125 5468.68603515625 C 1991.700439453125 5469.029296875 1991.8671875 5469.33740234375 1992.130859375 5469.5478515625 M 2009.039306640625 5472.166015625 L 2009.039184570312 5472.166015625 L 1992.960205078125 5470.53173828125 C 1991.879638671875 5470.53173828125 1991.00048828125 5469.70361328125 1991.00048828125 5468.68603515625 L 1991.00048828125 5456.98828125 C 1991.00048828125 5455.970703125 1991.879638671875 5455.142578125 1992.960205078125 5455.142578125 L 2009.039306640625 5452.16650390625 C 2010.120727539062 5452.16650390625 2011.000366210938 5452.99462890625 2011.000366210938 5454.01220703125 L 2011.000366210938 5470.31884765625 C 2011.000366210938 5471.33740234375 2010.12060546875 5472.166015625 2009.039306640625 5472.166015625 Z M 2007.671508789062 5454.00927734375 L 1994.035400390625 5456.56494140625 C 1993.118408203125 5456.56494140625 1992.372436523438 5457.27587890625 1992.372436523438 5458.14990234375 L 1992.372436523438 5468.19580078125 C 1992.372436523438 5469.0703125 1993.118530273438 5469.7822265625 1994.035522460938 5469.7822265625 L 2007.67138671875 5471.18408203125 C 2008.587646484375 5471.18408203125 2009.333129882812 5470.47265625 2009.333129882812 5469.59814453125 L 2009.333129882812 5455.59423828125 C 2009.333129882812 5454.72021484375 2008.587646484375 5454.00927734375 2007.671508789062 5454.00927734375 L 2007.671508789062 5454.00927734375 L 2007.67138671875 5454.00927734375 C 2007.67138671875 5454.00927734375 2007.671508789062 5454.00927734375 2007.671508789062 5454.00927734375 Z",
              stroke: "none",
            }
          })
        ]),
        h("text", {
          attrs: {
            transform: "translate(17.067 312.077)",
            "font-size": "11",
            'font-family': "Arial-BoldMT, Arial",
            'font-weight': "700",
            'letter-spacing': "-0.07em"
          }
        }, [
          h("tspan", {attrs: {x: "0", y: "0"}}, "TV")
        ])
      ])
    ]);
  }
};

var SafrasPodcastIcon = {
  name: 'SafrasPodcastIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "12.857",
        height: "20",
        viewBox: "0 0 12.857 20",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(-242 -60.986)"}}, [
        h("path", {
          attrs: {
            d: "M305.571,73.843a3.575,3.575,0,0,0,3.571-3.571V64.557a3.571,3.571,0,1,0-7.143,0v5.714A3.575,3.575,0,0,0,305.571,73.843Z",
            transform: "translate(-57.143)"
          }
        }),
        h("path", {
          attrs: {
            d: "M242,180.986v.714h11.429v2.857a5,5,0,0,1-10,0V181.7a.714.714,0,1,0-1.429,0v2.857a6.438,6.438,0,0,0,5.714,6.389v2.9h-2.143a.714.714,0,1,0,0,1.429h5.714a.714.714,0,1,0,0-1.429h-2.143v-2.9a6.438,6.438,0,0,0,5.714-6.389v-3.571Z",
            transform: "translate(0 -114.286)",
          }
        })
      ])
    ]);
  }
};

var CursosIcon = {
  name: 'CursosIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "21.5",
        height: "18.323",
        viewBox: "0 0 21.5 18.323",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(0 -37.825)"}}, [
        h("g", {attrs: {transform: "translate(0 37.825)"}}, [
          h("path", {
            attrs: {
              d: "M21.459,50.923A1.888,1.888,0,0,0,20.2,49.146v-6.5l1.3-.519-10.764-4.3L0,42.127l5.082,2.036v2.99A2.769,2.769,0,0,0,6.9,49.493a8.771,8.771,0,0,0,3.835.8,8.771,8.771,0,0,0,3.835-.8,2.769,2.769,0,0,0,1.819-2.339V44.169l2.555-1.021v6a1.884,1.884,0,0,0-.182,3.478l-1.042,3.126,1.192.4.661-1.982.661,1.982,1.192-.4-1.042-3.126A1.887,1.887,0,0,0,21.459,50.923Zm-6.325-3.77c0,.89-1.881,1.885-4.4,1.885s-4.4-1-4.4-1.885V44.667l4.4,1.762,4.4-1.758v2.482Zm-4.4-2.077L3.378,42.127l7.359-2.949,7.378,2.949Zm8.837,6.475a.628.628,0,1,1,.628-.628A.629.629,0,0,1,19.574,51.551Z",
              transform: "translate(0 -37.825)"
            }
          })
        ])
      ])
    ]);
  }
};

var PalestrasIcon = {
  name: 'PalestrasIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "22.554",
        height: "19.725",
        viewBox: "0 0 22.554 19.725",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [
      h("path", {
        attrs: {
          d: "M20.478,0H10.569A2.079,2.079,0,0,0,8.493,2.076V8.433l-1.84-.915c-.062-.031-.125-.06-.189-.088a3.138,3.138,0,1,0-4.329.192A4.182,4.182,0,0,0,0,11.277V13.4a2.08,2.08,0,0,0,1.415,1.969v3.694a.661.661,0,0,0,.661.661H6.323a.661.661,0,0,0,.661-.661V11.638L9.1,12.7a1.813,1.813,0,0,0,2.4-.758h2.369l-2.509,6.9a.661.661,0,0,0,1.242.452l2.673-7.35h.463l2.7,7.352a.661.661,0,0,0,1.24-.456l-2.533-6.9h3.328a2.076,2.076,0,0,0,2.076-2.076V2.076A2.076,2.076,0,0,0,20.478,0ZM2.383,5.261A1.816,1.816,0,1,1,4.2,7.077,1.818,1.818,0,0,1,2.383,5.261Zm7.991,5.97,0,.015a.489.489,0,0,1-.679.268L6.618,9.978a.661.661,0,0,0-.956.591V18.4H2.737V14.816a.661.661,0,0,0-.661-.661.755.755,0,0,1-.755-.755V11.277A2.879,2.879,0,0,1,4.2,8.4h.584a2.879,2.879,0,0,1,1.281.3l4.112,2.046A.4.4,0,0,1,10.374,11.231Zm10.859-1.37a.75.75,0,0,1-.221.534.76.76,0,0,1-.534.221H11.647l0-.011,1.64-3.28A.661.661,0,1,0,12.1,6.735l-1.4,2.8L9.815,9.09V2.076a.756.756,0,0,1,.755-.755h9.909a.759.759,0,0,1,.534.221.749.749,0,0,1,.221.533Zm0,0"
        }
      }),
      h("path", {
        attrs: {
          d: "M264.8,64.266h-7.078a.661.661,0,1,0,0,1.322H264.8a.661.661,0,1,0,0-1.322Zm0,0",
          transform: "translate(-245.742 -61.435)"
        }
      }),
      h("path", {
        attrs: {
          d: "M341.6,120.5h-3.539a.661.661,0,1,0,0,1.322H341.6a.661.661,0,1,0,0-1.322Zm0,0",
          transform: "translate(-322.536 -115.192)"
        }
      }),
      h("path", {
        attrs: {
          d: "M341.6,176.734h-3.539a.661.661,0,0,0,0,1.322H341.6a.661.661,0,1,0,0-1.322Zm0,0",
          transform: "translate(-322.536 -168.949)"
        }
      })
    ]);
  }
};

var CambioIcon = {
  name: 'CambioIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "14",
        height: "24",
        viewBox: "0 0 14 24",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(-5)"}}, [
        h("line", {
          attrs: {
            y2: "22",
            transform: "translate(12 1)",
            'stroke-linecap': "round",
            'stroke-linejoin': "round",
            'stroke-width': "2",
            stroke: "currentColor",
            fill: "none"
          }
        }),
        h("path", {
          attrs: {
            d: "M17,5H9.5a3.5,3.5,0,0,0,0,7h5a3.5,3.5,0,1,1,0,7H6",
            'stroke-linecap': "round",
            'stroke-linejoin': "round",
            'stroke-width': "2",
            stroke: "currentColor",
            fill: "none",
          }
        })
      ])
    ]);
  }
};

var ConsultoriaIcon = {
  name: 'ConsultoriaIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "27.779",
        height: "17.243",
        viewBox: "0 0 27.779 17.243",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(-28.316 -112)"}}, [

        h("g", {attrs: {transform: "translate(35.105 112)"}}, [
          h("g", {attrs: {transform: "translate(0 0)"}}, [
            h("path", {
              attrs: {
                d: "M134.528,7.311a3.646,3.646,0,0,0,2.242,2.778,2.457,2.457,0,0,0,1.646,0,3.714,3.714,0,0,0,2.249-2.774c.171-.014.4-.253.639-1.114.332-1.175-.021-1.35-.321-1.321a3.113,3.113,0,0,0,.129-.482c.507-3.045-.992-3.149-.992-3.149a2.313,2.313,0,0,0-.9-.839,3.051,3.051,0,0,0-1.853-.393,2.766,2.766,0,0,0-.739.139h0a3.248,3.248,0,0,0-.814.418,4.267,4.267,0,0,0-.835.693,3.391,3.391,0,0,0-.9,1.585,3.441,3.441,0,0,0,.007,1.549h0a3.01,3.01,0,0,0,.129.482c-.3-.029-.653.146-.321,1.321C134.132,7.058,134.357,7.3,134.528,7.311Z",
                transform: "translate(-130.325 0)"
              }
            }),
            h("path", {
              attrs: {
                d: "M50.919,275.981a11.324,11.324,0,0,1-3.306-1.507l-1.157,3.659-.218.689,0-.011-.189.586-.61-1.732c1.5-2.092-.3-2.071-.4-2.067s-1.9-.025-.4,2.067l-.61,1.732-.189-.586,0,.011-.218-.689-1.16-3.659a11.324,11.324,0,0,1-3.306,1.507c-1.36.346-1.424,1.917-1.371,2.692,0,0,.079,1.053.157,1.517a13.954,13.954,0,0,0,7.1,1.728,13.911,13.911,0,0,0,7.1-1.728c.079-.464.157-1.517.157-1.517C52.344,277.9,52.28,276.327,50.919,275.981Z",
                transform: "translate(-37.758 -264.675)"
              }
            }),
          ])
        ]),

        h("g", {attrs: {transform: "translate(44.316 114.32)"}}, [
          h("g", {attrs: {transform: "translate(0 0)"}}, [
            h("path", {
              attrs: {
                d: "M134.381,5.92A2.953,2.953,0,0,0,136.2,8.169a1.989,1.989,0,0,0,1.333,0A3.008,3.008,0,0,0,139.35,5.92c.139-.012.321-.205.517-.9.269-.951-.017-1.093-.26-1.07a2.522,2.522,0,0,0,.1-.39c.411-2.466-.8-2.55-.8-2.55a1.873,1.873,0,0,0-.731-.679,2.47,2.47,0,0,0-1.5-.318,2.24,2.24,0,0,0-.6.113h0a2.63,2.63,0,0,0-.659.338,3.455,3.455,0,0,0-.676.561,2.746,2.746,0,0,0-.731,1.284,2.787,2.787,0,0,0,.006,1.255h0a2.438,2.438,0,0,0,.1.39c-.243-.023-.529.119-.26,1.07C134.06,5.715,134.242,5.909,134.381,5.92Z",
                transform: "translate(-130.977 0)"
              }
            }),
            h("path", {
              attrs: {
                d: "M48.415,275.694a9.168,9.168,0,0,1-2.677-1.22c-1.158,1.739-3.631.89-4.183,0a9.168,9.168,0,0,1-2.677,1.22c-1.1.28-1.153,1.552-1.11,2.18,0,0,.064.853.127,1.229a11.3,11.3,0,0,0,5.753,1.4,11.264,11.264,0,0,0,5.753-1.4c.064-.376.127-1.229.127-1.229C49.569,277.246,49.517,275.974,48.415,275.694Z",
                transform: "translate(-37.758 -266.539)"
              }
            }),
          ])
        ]),

        h("g", {attrs: {transform: "translate(28.316 114.32)"}}, [
          h("g", {attrs: {transform: "translate(0 0)"}}, [
            h("path", {
              attrs: {
                d: "M134.381,5.92A2.953,2.953,0,0,0,136.2,8.169a1.989,1.989,0,0,0,1.333,0A3.008,3.008,0,0,0,139.35,5.92c.139-.012.321-.205.517-.9.269-.951-.017-1.093-.26-1.07a2.522,2.522,0,0,0,.1-.39c.411-2.466-.8-2.55-.8-2.55a1.873,1.873,0,0,0-.731-.679,2.47,2.47,0,0,0-1.5-.318,2.24,2.24,0,0,0-.6.113h0a2.63,2.63,0,0,0-.659.338,3.455,3.455,0,0,0-.676.561,2.746,2.746,0,0,0-.731,1.284,2.787,2.787,0,0,0,.006,1.255h0a2.438,2.438,0,0,0,.1.39c-.243-.023-.529.119-.26,1.07C134.06,5.715,134.242,5.909,134.381,5.92Z",
                transform: "translate(-130.977 0)"
              }
            }),
            h("path", {
              attrs: {
                d: "M48.415,275.694a9.168,9.168,0,0,1-2.677-1.22c-1.158,1.739-3.631.89-4.183,0a9.168,9.168,0,0,1-2.677,1.22c-1.1.28-1.153,1.552-1.11,2.18,0,0,.064.853.127,1.229a11.3,11.3,0,0,0,5.753,1.4,11.264,11.264,0,0,0,5.753-1.4c.064-.376.127-1.229.127-1.229C49.569,277.246,49.517,275.974,48.415,275.694Z",
                transform: "translate(-37.758 -266.539)"
              }
            }),
          ])
        ])

      ])
    ]);
  }
};

var NewsIcon = {
  name: 'NewsIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "26",
        height: "21.185",
        viewBox: "0 0 26 21.185",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(-338 -212.407)"}}, [
        h("path", {
          attrs: {
            d: "M23.562,21.185H3.25A3.189,3.189,0,0,1,0,17.925V0H22.749V3.26H26V17.925C26,21.134,23.562,21.185,23.562,21.185Zm-2.437-3.26V1.629H1.624v16.3A1.595,1.595,0,0,0,3.25,19.554H21.674a2.362,2.362,0,0,1-.549-1.629ZM3.25,8.148h7.313V16.3H3.25ZM19.5,9.778H12.187V8.148H19.5Zm0,3.26H12.187v-1.63H19.5v1.629ZM17.875,16.3H12.187v-1.63h5.687V16.3ZM3.25,4.889H19.5V6.518H3.25Z",
            transform: "translate(338.001 212.407)"
          }
        })
      ])
    ]);
  }
};

var FutureMarketIcon = {
  name: 'FutureMarketIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.956",
        height: "20.956",
        viewBox: "0 0 20.956 20.956",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(-336.669 -453)"}}, [
        h("g", {attrs: {transform: "translate(-137.331 45)"}}, [
          h("g", {attrs: {transform: "translate(474 408)"}}, [
            h("g", {attrs: {transform: "translate(0 0)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M20.344,9.864a.614.614,0,0,0-.614.614A9.246,9.246,0,1,1,14.9,2.35l-.768.768a.614.614,0,0,0,.434,1.048H17.5a.614.614,0,0,0,.614-.614V.614A.614.614,0,0,0,17.069.18L15.8,1.449A10.479,10.479,0,0,0,3.071,17.887a10.478,10.478,0,0,0,17.887-7.409A.614.614,0,0,0,20.344,9.864Z",
                    transform: "translate(-0.002 0)"
                  }
                })
              ])
            ])
          ]),
          h("line", {
            attrs: {
              y2: "12.446",
              transform: "translate(484.615 412.393)",
              'stroke-linecap': "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              "fill": "none",
              stroke: "currentColor"
            }
          }, []),
          h("path", {
            attrs: {
              d: "M12.4,5H8.037a2.037,2.037,0,0,0,0,4.073h2.909a2.037,2.037,0,0,1,0,4.073H6",
              transform: "translate(474.955 409.72)",
              'stroke-linecap': "round",
              "stroke-linejoin": "round",
              "stroke-width": "2",
              "fill": "none",
              stroke: "currentColor",
            }
          }),
        ]),
      ])
    ]);
  }
};

var FisicoIcon = {
  name: 'FisicoIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "28",
          height: "28",
          viewBox: "0 0 256 256",
        },
        "class": "feather custom-consulting-icon"
      }, ctx.data]),
      [
        h("path", {attrs: {d: "M144.1,95.7c2.6,0,4.9-2.1,5-4.7l2.1-37.1c0.2-2.8-2-5.1-4.7-5.3c-2.8-0.2-5.1,2-5.3,4.7l-2.1,37.1c-0.2,2.8,2,5.1,4.7,5.3   C143.9,95.7,144,95.7,144.1,95.7z"}}),
        h("path", {attrs: {d: "M173.9,82.2c2.6,0,4.9-2.1,5-4.7l2.2-38.9c0.2-2.8-2-5.1-4.7-5.3c-2.7-0.2-5.1,2-5.3,4.7l-2.2,38.9c-0.2,2.8,2,5.1,4.7,5.3   C173.7,82.2,173.8,82.2,173.9,82.2z"}}),
        h("path", {
          attrs: {d: "M246.7,164.4c-4.7-5.8-12.4-7.7-19.2-4.8l-61.9,26c-2.6,1.1-3.8,4-2.7,6.6c1.1,2.6,4,3.8,6.6,2.7l61.9-26   c2.6-1.1,5.7-0.3,7.5,1.9c1.1,1.4,1.6,3.2,1.3,5c-0.3,1.8-1.3,3.4-2.9,4.4c-27,17.6-88.5,52.4-91.4,54.1c-0.1,0.1-0.2,0.1-0.3,0.2   l0,0c-7.5,4.4-15.8,5.6-26.4,3.8c-0.6-0.1-11.2-1.4-49.3-6.1L53,229.9v-67.7c2.8-0.2,5.2-0.3,6.3-0.3l0.6,0   c23.4-1.5,45.7,3,69.3,7.8c3,0.6,6.1,1.2,9.1,1.8c3.2,0.6,5.6,3.5,5.6,6.8c0,0.2,0,0.4-0.1,0.8c-0.2,1.9-1.2,3.3-2,4   c-1.3,1.3-3,2-4.9,2H89.8c-2.8,0-5,2.2-5,5c0,2.8,2.2,5,5,5h47.3c4.5,0,8.8-1.8,12-5c2.7-2.8,4.4-6.2,4.8-9.7   c0.1-0.7,0.2-1.5,0.2-2.2c0-8.1-5.8-15.1-13.7-16.6c-3-0.6-6-1.2-9-1.8c-23.2-4.7-47.3-9.6-71.9-8l-0.5,0c-1.1,0.1-3.5,0.2-6.1,0.3   c-0.6-2.1-2.4-3.7-4.8-3.7H10.7c-2.8,0-5,2.2-5,5v84.4c0,2.8,2.2,5,5,5H48c2,0,3.7-1.2,4.5-2.9l16.2,2c20.1,2.5,47.6,5.8,48.8,6   c3.7,0.7,7.3,1,10.7,1c8.3,0,15.7-2,22.4-5.9c0.1,0,0.1-0.1,0.2-0.1c0.6-0.4,64.2-36.3,92-54.4c3.9-2.5,6.6-6.6,7.3-11.2   C250.8,172.7,249.6,168,246.7,164.4z M43,232.9H15.7v-74.3H43V232.9z"}
        }),
        h("path", {attrs: {d: "M122.8,100.6c2.3-1.6,2.8-4.8,1.2-7c-9-12.6-8.3-29.1,1.7-41c20-23.7,51.6-32.2,76.3-35.1c1,14.2-1,30.1-5.6,45.5   c-1.7,5.6-17.5,54.5-51.3,44.4c-1.4-0.5-10.3-4.5-12.2-5.6c-1.1-0.8-2.5-1.2-3.9-1c-6.4,1.1-12.9,24-13.4,34.8   c-0.1,2.8,2,5.1,4.8,5.2c0.1,0,0.2,0,0.2,0c2.7,0,4.9-2.1,5-4.8c0.4-9.4,3.9-18.7,6.1-23.7c0.7,0.3,1.5,0.7,2.4,1.1   c1.6,0.7,6.7,3.1,8,3.4c32.9,9.8,55-21.4,63.9-51.1c5.5-18.4,7.5-37.6,5.5-54.6c-0.5-2.6-3.1-4.6-5.8-4.4   c-38.8,3.6-69.1,17.2-87.7,39.1c-13.1,15.5-14,36.9-2.2,53.3C117.4,101.7,120.5,102.3,122.8,100.6z"}}),
      ],
    );
  }
};

var IndicadoresIcon = {
  name: 'IndicadoresIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "28",
          height: "28",
          viewBox: "0 0 512 512",
        },
        "class": "feather custom-consulting-icon"
      }, ctx.data]),
      [
        h("path", {attrs: {d: "m76 240c12.101562 0 23.054688-4.855469 31.148438-12.652344l44.402343 22.199219c-.222656 1.808594-.550781 3.585937-.550781 5.453125 0 24.8125 20.1875 45 45 45s45-20.1875 45-45c0-6.925781-1.703125-13.410156-4.511719-19.277344l60.234375-60.234375c5.867188 2.808594 12.351563 4.511719 19.277344 4.511719 24.8125 0 45-20.1875 45-45 0-4.671875-.917969-9.089844-2.246094-13.328125l52.335938-39.242187c7.140625 4.769531 15.699218 7.570312 24.910156 7.570312 24.8125 0 45-20.1875 45-45s-20.1875-45-45-45-45 20.1875-45 45c0 4.671875.917969 9.089844 2.246094 13.328125l-52.335938 39.242187c-7.140625-4.769531-15.699218-7.570312-24.910156-7.570312-24.8125 0-45 20.1875-45 45 0 6.925781 1.703125 13.410156 4.511719 19.277344l-60.234375 60.234375c-5.867188-2.808594-12.351563-4.511719-19.277344-4.511719-12.101562 0-23.054688 4.855469-31.148438 12.652344l-44.402343-22.199219c.222656-1.808594.550781-3.585937.550781-5.453125 0-24.8125-20.1875-45-45-45s-45 20.1875-45 45 20.1875 45 45 45zm0 0"}}),
        h("path", {attrs: {d: "m497 482h-16v-317c0-8.289062-6.710938-15-15-15h-60c-8.289062 0-15 6.710938-15 15v317h-30v-227c0-8.289062-6.710938-15-15-15h-60c-8.289062 0-15 6.710938-15 15v227h-30v-107c0-8.289062-6.710938-15-15-15h-60c-8.289062 0-15 6.710938-15 15v107h-30v-167c0-8.289062-6.710938-15-15-15h-60c-8.289062 0-15 6.710938-15 15v167h-16c-8.289062 0-15 6.710938-15 15s6.710938 15 15 15h482c8.289062 0 15-6.710938 15-15s-6.710938-15-15-15zm0 0"}}),
      ],
    );
  }
};

var ClimaIcon = {
  name: 'ClimaIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "30",
          height: "24",
          viewBox: "0 0 30 24",
        },
        "class": "feather custom-consulting-icon"
      }, ctx.data]),
      [
        h("path", {
          attrs: {
            d: "M18.564,47.812a7.257,7.257,0,0,0-6.311,3.666,6.394,6.394,0,0,0-7.467,6.635A5.129,5.129,0,0,0,5.129,68.36h13a6.4,6.4,0,0,0,6-8.611A7.272,7.272,0,0,0,18.564,47.812Zm0,1.935a5.335,5.335,0,0,1,4.507,8.169,6.386,6.386,0,0,0-5.878-2.278,6.39,6.39,0,0,0-3.06-3.523A5.324,5.324,0,0,1,18.564,49.748Zm-.439,16.677h-13a3.194,3.194,0,1,1,.6-6.332.968.968,0,0,0,1.131-1.125,9.566,9.566,0,0,1-.152-1.188,4.46,4.46,0,0,1,8.844-.818.968.968,0,0,0,.452.653c.608.366.862-.108,2.124-.108a4.459,4.459,0,1,1,0,8.918ZM30,55.07a.968.968,0,0,1-.968.968H27.944a.968.968,0,1,1,0-1.935h1.089A.968.968,0,0,1,30,55.07ZM17.592,45.7V44.607a.968.968,0,1,1,1.935,0V45.7a.968.968,0,1,1-1.935,0Zm9.056,1.29a.968.968,0,0,1,0,1.369l-.77.77a.968.968,0,1,1-1.369-1.369l.77-.77a.968.968,0,0,1,1.369,0ZM10.474,48.36a.968.968,0,1,1,1.369-1.369l.77.77a.968.968,0,1,1-1.369,1.369Z",
            transform: "translate(0 -43.639)"
          }
        }),
      ],
    );
  }
};

var MeusAtivosIcon = {
  name: 'MeusAtivosIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.204",
        height: "20.718",
        viewBox: "0 0 20.204 20.718",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(0.204 -1.167)"}}, [
        h("g", {attrs: {transform: "translate(0 1.167)"}}, [
          h("g", {attrs: {transform: "translate(0 0)"}}, [
            h("path", {
              attrs: {
                d: "M20,0H0V10.176H20V0Z",
                fill: "none",
              }
            }),
            h("g", {attrs: {transform: "translate(-0.204 1.257)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M90.305,75.167c-.231-.232,4.682-.232,4.45,0l-7.139,7.121-3.943-3.943a.592.592,0,0,0-.837,0l-5.269,5.269a.592.592,0,1,0,.837.837L83.255,79.6,87.2,83.542a.592.592,0,0,0,.836,0L95.591,76C95.822,75.774,90.536,75.4,90.305,75.167Z",
                    transform: "translate(-77.393 -74.993)",
                  }
                }),
              ]),
            ]),
            h("g", {attrs: {transform: "translate(12.543 1.238)"}}, [
              h("g", {attrs: {transform: "translate(0 0)"}}, [
                h("path", {
                  attrs: {
                    d: "M332.79,74.344h-4.44a.592.592,0,0,0,0,1.184H332.2v3.849a.592.592,0,1,0,1.184,0v-4.44A.592.592,0,0,0,332.79,74.344Z",
                    transform: "translate(-327.758 -74.344)",
                  }
                }),
              ]),
            ]),
          ]),
        ]),
        h("path", {
          attrs: {
            d: "M1,7.669H1c-.552,0-1-.3-1-.676L0,.676C0,.3.45,0,1,0S2,.3,2,.676V6.993c0,.373-.448.676-1,.676",
            transform: "translate(0.979 14.12)",
          }
        }),
        h("path", {
          attrs: {
            d: "M1,10.277H1c-.552,0-1-.3-1-.676L0,.676C0,.3.45,0,1,0S2,.3,2,.676V9.6c0,.373-.448.676-1,.676",
            transform: "translate(4.907 11.607)",
          }
        }),
        h("path", {
          attrs: {
            d: "M1,7.66H1c-.552,0-1-.3-1-.676L0,.676C0,.3.45,0,1,0H1c.55,0,1,.3,1,.676V6.984c0,.373-.448.676-1,.676",
            transform: "translate(9.548 14.115)",
          }
        }),
        h("path", {
          attrs: {
            d: "M1,10.277H1c-.552,0-1-.3-1-.676L0,.676C0,.3.45,0,1,0S2,.3,2,.676V9.6c0,.373-.448.676-1,.676",
            transform: "translate(14.188 11.607)",
          }
        }),
      ])
    ]);
  }
};


var WhatsHedgeIcon = {
  name: 'WhatsHedgeIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20.82",
        height: "20.82",
        viewBox: "0 0 20.82 20.82",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("g", {attrs: {transform: "translate(-3.036 2.109)"}}, [
        h("g", {attrs: {transform: "translate(3.036 -2.109)"}}, [
          h("g", {attrs: {transform: "translate(0)"}}, [
            h("path", {
              attrs: {
                d: "M20.82,14.09a6.745,6.745,0,0,0-4.928-6.485A7.95,7.95,0,1,0,1.1,11.991L.029,15.871,3.909,14.8a7.92,7.92,0,0,0,3.7,1.094,6.732,6.732,0,0,0,9.91,3.993l3.276.906-.906-3.276A6.706,6.706,0,0,0,20.82,14.09ZM4.1,13.478l-2.323.643L2.421,11.8l-.146-.229a6.728,6.728,0,1,1,2.056,2.056Zm14.94,5.563-1.723-.477-.23.15a5.512,5.512,0,0,1-8.221-2.868,7.965,7.965,0,0,0,6.98-6.98,5.512,5.512,0,0,1,2.867,8.221l-.15.23Zm0,0"
              }
            }),
            h("path", {
              attrs: {
                d: "M180.5,271h1.22v1.22H180.5Zm0,0",
                transform: "translate(-173.16 -259.98)",
              }
            }),
            h("path", {
              attrs: {
                d: "M139.16,92.44a1.207,1.207,0,0,1-.4.9l-1.433,1.311V96.14h1.22v-.951l1.036-.949a2.44,2.44,0,1,0-4.086-1.8h1.22a1.22,1.22,0,1,1,2.44,0Zm0,0",
                transform: "translate(-129.99 -86.34)",
              }
            })
          ]),
        ]),
      ])
    ]);
  }
};

var HedgeCommoditiesIcon = {
  name: 'HedgeCommoditiesIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19.841",
        height: "19.841",
        viewBox: "0 0 19.841 19.841",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("path", {
        attrs: {
          d: "M9.437,4.96a.62.62,0,0,1-.388-1.1l2.81-2.249a.194.194,0,0,0,.067-.23.189.189,0,0,0-.191-.138H4.047a.188.188,0,0,0-.191.138.193.193,0,0,0,.066.229L6.733,3.857a.62.62,0,1,1-.775.968L3.147,2.576A1.429,1.429,0,0,1,2.685.969,1.428,1.428,0,0,1,4.047,0h7.689A1.427,1.427,0,0,1,13.1.968a1.43,1.43,0,0,1-.464,1.608L9.825,4.824A.618.618,0,0,1,9.437,4.96Z",
          transform: "translate(-0.451)",
        }
      }),

      h("path", {
        attrs: {
          d: "M12.3,5.74H3.62a.62.62,0,0,1,0-1.24H12.3a.62.62,0,0,1,0,1.24Z",
          transform: "translate(-0.52 -0.78)",
        }
      }),
      h("path", {
        attrs: {
          d: "M8.881,17.287H7.12a.62.62,0,0,1,0-1.24H8.881a.517.517,0,0,0,0-1.033H8.253a1.757,1.757,0,0,1,0-3.513h1.761a.62.62,0,0,1,0,1.24H8.253a.517.517,0,0,0,0,1.033h.628a1.757,1.757,0,0,1,0,3.513Z",
          transform: "translate(-1.126 -1.993)",
        }
      }),
      h("path", {
        attrs: {
          d: "M8.87,12.273a.62.62,0,0,1-.62-.62V10.62a.62.62,0,0,1,1.24,0v1.033A.62.62,0,0,1,8.87,12.273Z",
          transform: "translate(-1.43 -1.733)",
        }
      }),
      h("path", {
        attrs: {
          d: "M8.87,19.523a.62.62,0,0,1-.62-.62V17.87a.62.62,0,0,1,1.24,0V18.9A.62.62,0,0,1,8.87,19.523Z",
          transform: "translate(-1.43 -2.989)",
        }
      }),
      h("path", {
        attrs: {
          d: "M14.979,11.015a.619.619,0,0,1-.571-.38,10.57,10.57,0,0,0-3.85-4.978.62.62,0,1,1,.626-1.07,11.8,11.8,0,0,1,4.367,5.569.62.62,0,0,1-.332.811.633.633,0,0,1-.24.048Z",
          transform: "translate(-1.776 -0.78)",
        }
      }),
      h("path", {
        attrs: {
          d: "M10.127,20.621H4.754C1.47,20.621,0,17.818,0,15.04,0,11.181,2.558,6.3,5.473,4.585A.62.62,0,0,1,6.1,5.655C3.557,7.147,1.24,11.62,1.24,15.04c0,2,.92,4.34,3.513,4.34h5.374a.62.62,0,1,1,0,1.24Z",
          transform: "translate(0 -0.78)",
        }
      }),
      h("path", {
        attrs: {
          d: "M20.994,22.787H16.447A1.448,1.448,0,0,1,15,21.34V18.447A1.448,1.448,0,0,1,16.447,17h4.547a1.448,1.448,0,0,1,1.447,1.447V21.34A1.448,1.448,0,0,1,20.994,22.787ZM16.447,18.24a.207.207,0,0,0-.207.207V21.34a.207.207,0,0,0,.207.207h4.547a.207.207,0,0,0,.207-.207V18.447a.207.207,0,0,0-.207-.207Z",
          transform: "translate(-2.599 -2.946)",
        }
      }),
      h("path", {
        attrs: {
          d: "M20.513,17.547H17.62a.62.62,0,0,1-.62-.62v-1.86a2.067,2.067,0,1,1,4.134,0v1.86A.62.62,0,0,1,20.513,17.547Zm-2.273-1.24h1.653v-1.24a.827.827,0,1,0-1.653,0Z",
          transform: "translate(-2.946 -2.253)",
        }
      })

    ]);
  }
};

var HedgeCambialIcon = {
  name: 'HedgeCambialIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "19.754",
        height: "19.716",
        viewBox: "0 0 19.754 19.716",
      },
      "class": "feather custom-consulting-icon"
    }, ctx.data]), [

      h("path", {
        attrs: {
          d: "M45.3,98.951a.77.77,0,1,0-.169-1.076A.765.765,0,0,0,45.3,98.951Z",
          transform: "translate(-43.245 -93.814)",
        }
      }),
      h("path", {
        attrs: {
          d: "M12.013,164.671a.77.77,0,1,0-.494-.97A.764.764,0,0,0,12.013,164.671Z",
          transform: "translate(-11.037 -156.892)",
        }
      }),
      h("path", {
        attrs: {
          d: "M97.869,47a.77.77,0,0,0,.453-.148h0a.77.77,0,1,0-.452.148Z",
          transform: "translate(-93.352 -43.725)",
        }
      }),
      h("path", {
        attrs: {
          d: "M.015,236.963c.005.025.011.049.018.073s.016.048.025.071a.749.749,0,0,0,.032.068.735.735,0,0,0,.039.065.636.636,0,0,0,.045.061.709.709,0,0,0,.051.056.7.7,0,0,0,.056.051.713.713,0,0,0,.061.045.8.8,0,0,0,.133.071c.023.01.047.018.071.025s.049.013.073.018a.7.7,0,0,0,.075.011.747.747,0,0,0,.152,0,.72.72,0,0,0,.075-.011c.025,0,.049-.011.073-.018s.048-.016.071-.025a.745.745,0,0,0,.068-.032.677.677,0,0,0,.065-.039.707.707,0,0,0,.061-.045.7.7,0,0,0,.056-.051.707.707,0,0,0,.051-.056.718.718,0,0,0,.045-.061.8.8,0,0,0,.071-.133c.01-.023.018-.047.025-.071s.013-.049.018-.073a.689.689,0,0,0,.011-.075.748.748,0,0,0,0-.152.722.722,0,0,0-.011-.075c-.005-.024-.011-.049-.018-.073s-.016-.048-.025-.071a.749.749,0,0,0-.032-.068.735.735,0,0,0-.039-.065.71.71,0,0,0-.045-.061.752.752,0,0,0-.107-.107.646.646,0,0,0-.061-.045.683.683,0,0,0-.065-.038.729.729,0,0,0-.068-.032c-.023-.01-.047-.018-.071-.025s-.049-.013-.073-.018a.7.7,0,0,0-.075-.011.766.766,0,0,0-.152,0,.724.724,0,0,0-.075.011c-.024.005-.049.011-.073.018s-.048.016-.071.025a.741.741,0,0,0-.068.032.735.735,0,0,0-.065.038.638.638,0,0,0-.061.045.752.752,0,0,0-.107.107.643.643,0,0,0-.045.061.8.8,0,0,0-.071.133c-.01.023-.018.047-.025.071s-.013.049-.018.073a.7.7,0,0,0-.011.075.748.748,0,0,0,0,.152A.709.709,0,0,0,.015,236.963Z",
          transform: "translate(0 -226.955)",
        }
      }),
      h("path", {
        attrs: {
          d: "M163.5,13.5a.77.77,0,1,0-.732-.532A.764.764,0,0,0,163.5,13.5Z",
          transform: "translate(-156.451 -11.521)",
        }
      }),
      h("path", {
        attrs: {
          d: "M169.938,90.685v.143a2.7,2.7,0,0,0,2.689,2.7h.97a1.154,1.154,0,0,1,1.155,1.151v.5a1.157,1.157,0,0,1-1.155,1.157H172.02a.841.841,0,0,1-.812-.847.77.77,0,0,0-1.54,0,2.373,2.373,0,0,0,2.352,2.387h.189v.809a.77.77,0,0,0,1.54,0v-.813a2.7,2.7,0,0,0,2.541-2.693v-.5a2.7,2.7,0,0,0-2.695-2.691h-.97a1.158,1.158,0,0,1-1.149-1.164v-.143a1.154,1.154,0,0,1,1.149-1.157h.917a.816.816,0,0,1,.822.809.77.77,0,0,0,1.54,0A2.357,2.357,0,0,0,173.75,88v-.9a.77.77,0,1,0-1.54,0v.918A2.7,2.7,0,0,0,169.938,90.685Z",
          transform: "translate(-163.122 -83.019)",
        }
      }),
      h("path", {
        attrs: {
          d: "M461.594,308.931a.77.77,0,1,0,.494.971A.77.77,0,0,0,461.594,308.931Z",
          transform: "translate(-442.815 -296.995)",
        }
      }),
      h("path", {
        attrs: {
          d: "M10.661,334.1l0-.013c0-.02-.005-.039-.009-.059a.764.764,0,0,0-.089-.238l-.021-.035-.015-.022c-.01-.014-.02-.028-.031-.042l-.012-.014c-.012-.015-.025-.029-.039-.043l-.009-.009c-.014-.013-.028-.026-.043-.039l-.015-.012-.041-.031-.022-.015-.035-.021a.764.764,0,0,0-.237-.089l-.06-.009a.78.78,0,0,0-.087-.005,8.36,8.36,0,0,1-7.112-4l1.76,0a.77.77,0,0,0,0-1.54h0l-2.253,0H2.281a2.257,2.257,0,0,0-1.608.663A2.3,2.3,0,0,0,0,330.177V332.4a.77.77,0,0,0,1.54,0V330.32a9.857,9.857,0,0,0,8.355,4.625h0a.718.718,0,0,0,.076,0h.01l.062-.009a.764.764,0,0,0,.236-.088l.037-.022.02-.014.043-.032.013-.011c.015-.013.03-.026.044-.04l.008-.008c.014-.014.027-.029.04-.044l.011-.014c.011-.014.022-.028.032-.042l.014-.02.023-.038a.764.764,0,0,0,.088-.236c0-.02.007-.04.009-.059v-.013a.713.713,0,0,0,0-.074h0A.7.7,0,0,0,10.661,334.1Z",
          transform: "translate(0.002 -315.229)",
        }
      }),
      h("path", {
        attrs: {
          d: "M245.435,2.27a.77.77,0,0,0-.77.77V5.124A9.857,9.857,0,0,0,236.308.5a.776.776,0,0,0-.086.005l-.062.009a.764.764,0,0,0-.235.088l-.038.023a.767.767,0,0,0-.075.056c-.016.013-.031.027-.045.041l-.007.007c-.014.014-.028.029-.041.045l-.011.013c-.011.014-.022.029-.033.044l-.013.019-.023.038a.766.766,0,0,0-.088.236c0,.02-.007.04-.009.06v.012a.707.707,0,0,0,0,.076.727.727,0,0,0,0,.076v.012c0,.02.005.04.009.06a.764.764,0,0,0,.088.236l.023.038.013.019c.01.015.021.029.032.043l.011.013c.013.015.026.03.04.044l.007.007c.014.014.029.028.044.04l.013.011.043.032.02.014.037.022a.764.764,0,0,0,.236.089l.061.009h.011a.723.723,0,0,0,.075,0,8.36,8.36,0,0,1,7.112,4l-1.76,0a.77.77,0,0,0,0,1.54h0l2.253,0h.008a2.257,2.257,0,0,0,1.608-.663,2.3,2.3,0,0,0,.675-1.651V3.04A.77.77,0,0,0,245.435,2.27Z",
          transform: "translate(-226.45 -0.499)",
        }
      }),
      h("path", {
        attrs: {
          d: "M428.318,374.664a.77.77,0,1,0,.169,1.076A.77.77,0,0,0,428.318,374.664Z",
          transform: "translate(-410.616 -360.086)",
        }
      }),
      h("path", {
        attrs: {
          d: "M473.6,236.661c-.005-.024-.011-.049-.018-.073s-.016-.048-.025-.071a.744.744,0,0,0-.032-.068.678.678,0,0,0-.039-.065.778.778,0,0,0-.1-.117.711.711,0,0,0-.056-.051.643.643,0,0,0-.061-.045.8.8,0,0,0-.133-.071c-.023-.01-.047-.018-.071-.025s-.049-.013-.073-.018a.7.7,0,0,0-.075-.011.766.766,0,0,0-.152,0,.723.723,0,0,0-.075.011c-.024.005-.049.011-.073.018s-.048.016-.071.025a.748.748,0,0,0-.068.032.727.727,0,0,0-.065.039.642.642,0,0,0-.061.045.7.7,0,0,0-.056.051.77.77,0,0,0-.1.117.678.678,0,0,0-.039.065.739.739,0,0,0-.032.068c-.01.023-.018.047-.025.071s-.013.049-.018.073a.7.7,0,0,0-.011.075.744.744,0,0,0,0,.152.733.733,0,0,0,.011.075c.005.024.011.049.018.073s.016.048.025.071a.746.746,0,0,0,.032.068.731.731,0,0,0,.039.065.771.771,0,0,0,.1.117.7.7,0,0,0,.056.051.723.723,0,0,0,.061.045.8.8,0,0,0,.133.071c.023.01.047.018.071.025s.049.013.073.018a.7.7,0,0,0,.075.011.767.767,0,0,0,.226-.011c.024-.005.049-.011.073-.018s.048-.016.071-.025a.748.748,0,0,0,.068-.032.736.736,0,0,0,.065-.039.76.76,0,0,0,.168-.152.718.718,0,0,0,.045-.061.8.8,0,0,0,.071-.133c.01-.023.018-.047.025-.071s.013-.049.018-.073a.7.7,0,0,0,.011-.075.767.767,0,0,0-.011-.226Z",
          transform: "translate(-453.865 -226.954)",
        }
      }),
      h("path", {
        attrs: {
          d: "M375.294,426.762a.77.77,0,1,0,1.076.169A.77.77,0,0,0,375.294,426.762Z",
          transform: "translate(-360.509 -410.174)",
        }
      }),
      h("path", {
        attrs: {
          d: "M309.865,460.145a.77.77,0,1,0,.97.494A.77.77,0,0,0,309.865,460.145Z",
          transform: "translate(-297.398 -442.375)",
        }
      }),


    ]);
  }
};


var HedgeIcon = {
  name: 'HedgeIcon',
  props: {
    size: {
      type: String,
      default: '24',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather custom-consulting-icon"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -1080)"}}, [
          h("g", {attrs: {transform: "translate(129 1085)"}}, [
            h("g", {attrs: {transform: "translate(0 0)"}}, [
              h("path", {
                attrs: {
                  d: "M41.647,19.994V8.332a.833.833,0,0,0-.54-.782L21.121.052a.845.845,0,0,0-.584,0L.543,7.55A.833.833,0,0,0,0,8.332v5.831a.833.833,0,0,0,1.667,0V8.907L20.827,1.716,39.988,8.907v11.06c-.32,13.226-3.064,20.118-19.153,28.247C4.739,40.093,1.995,33.2,1.674,19.994V18.328a.833.833,0,0,0-1.667,0v1.7C.341,33.785,3.373,41.365,20.454,49.912a.833.833,0,0,0,.746,0C38.281,41.365,41.313,33.785,41.645,20Z",
                  transform: "translate(0 0)"
                }
              }),
              h("path", {
                attrs: {
                  d: "M21.275,46.1a.833.833,0,0,0,.78,0C36.34,38.541,38.037,32.314,38.319,20.833V12.109a.833.833,0,0,0-.54-.782L21.952,5.393a.845.845,0,0,0-.584,0L5.547,11.327A.833.833,0,0,0,5,12.109v8.747C5.28,32.313,6.977,38.539,21.262,46.1ZM6.67,12.685l15-5.622,14.988,5.622v8.129c-.271,10.936-1.781,16.525-14.99,23.6C8.457,37.335,6.949,31.75,6.678,20.833Z",
                  transform: "translate(-0.839 -0.89)"
                }
              }),
              h("path", {
                attrs: {
                  d: "M13.386,14.531a.833.833,0,0,0-1.074-.488L9.538,15.081A.833.833,0,0,0,9,15.864V19a.833.833,0,1,0,1.667,0V16.442L12.9,15.6a.833.833,0,0,0,.488-1.074Z",
                  transform: "translate(-1.502 -2.334)"
                }
              }),
              h("path", {
                attrs: {
                  d: "M18.667,31.243a.833.833,0,0,0-1.667,0,5.959,5.959,0,0,0,5.831,5.368V37.5a.833.833,0,0,0,1.667,0v-.879a5.959,5.959,0,0,0,5.831-5.368A5.959,5.959,0,0,0,24.5,25.868V18.387a4.268,4.268,0,0,1,4.165,3.692.833.833,0,1,0,1.667,0A5.959,5.959,0,0,0,24.5,16.714v-.879a.833.833,0,1,0-1.667,0v.879A5.959,5.959,0,0,0,17,22.08a5.959,5.959,0,0,0,5.831,5.368v7.488a4.268,4.268,0,0,1-4.165-3.694Zm10,0A4.268,4.268,0,0,1,24.5,34.935V27.551a4.268,4.268,0,0,1,4.163,3.692Zm-10-9.165a4.268,4.268,0,0,1,4.165-3.692v7.385a4.268,4.268,0,0,1-4.165-3.692Z",
                  transform: "translate(-2.837 -2.502)"
                }
              }),
            ])
          ]),
        ])
      ]);
  }
};

var FertilizerIcon = {
  name: 'Fertilizer2Icon',
  props: {
    size: {
      type: String,
      default: '28',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -600)"}}, [
          h("g", {attrs: {transform: "translate(128.972 605)"}}, [
            h("g", {attrs: {transform: "translate(0.028 0)"}}, [
              h("path", {
                attrs: {
                  d: "M8.473,47.75a62.1,62.1,0,0,0,12.338,1.417A62.1,62.1,0,0,0,33.15,47.75,10.4,10.4,0,0,0,39.315,50,2.185,2.185,0,0,0,41.4,48.356a8.015,8.015,0,0,0-2.173-7.394A102.905,102.905,0,0,0,40.811,25,102.9,102.9,0,0,0,39.234,9.038a8.012,8.012,0,0,0,2.173-7.394A2.185,2.185,0,0,0,39.319,0a10.4,10.4,0,0,0-6.167,2.25A62.1,62.1,0,0,0,20.811.833,62.1,62.1,0,0,0,8.473,2.25,10.4,10.4,0,0,0,2.3,0,2.185,2.185,0,0,0,.213,1.644,8.015,8.015,0,0,0,2.388,9.038,102.905,102.905,0,0,0,.811,25,102.9,102.9,0,0,0,2.388,40.962,8.015,8.015,0,0,0,.213,48.356,2.185,2.185,0,0,0,2.3,50a10.4,10.4,0,0,0,6.169-2.25Zm-6.683.063a6.394,6.394,0,0,1,.975-4.706c.052.283.1.554.15.81a.834.834,0,0,0,1.638-.31A110.63,110.63,0,0,1,2.475,25,110.632,110.632,0,0,1,4.553,6.388a.833.833,0,1,0-1.638-.306c-.048.256-.1.527-.15.81a6.394,6.394,0,0,1-.975-4.7c.177-.521.4-.521.512-.521A9.075,9.075,0,0,1,6.263,2.75l-.25.062a.833.833,0,1,0,.4,1.617,63.735,63.735,0,0,1,14.4-1.923,63.734,63.734,0,0,1,14.4,1.923.833.833,0,1,0,.4-1.617l-.25-.062a9.075,9.075,0,0,1,3.962-1.081c.108,0,.333,0,.513.519a6.394,6.394,0,0,1-.975,4.706c-.052-.283-.1-.554-.15-.81a.833.833,0,0,0-1.637.31A110.631,110.631,0,0,1,39.144,25a110.63,110.63,0,0,1-2.075,18.612.833.833,0,0,0,1.637.31c.048-.256.1-.527.15-.81a6.394,6.394,0,0,1,.975,4.706c-.177.519-.4.519-.513.519a9.075,9.075,0,0,1-3.962-1.083l.25-.062a.833.833,0,1,0-.4-1.617,63.735,63.735,0,0,1-14.4,1.923,63.735,63.735,0,0,1-14.4-1.923.833.833,0,1,0-.4,1.617l.25.062A9.075,9.075,0,0,1,2.3,48.335c-.108,0-.335,0-.512-.519Z",
                  transform: "translate(-0.028 0)"
                }
              }),
              h("path", {
                attrs: {
                  d: "M10,27.5A12.5,12.5,0,1,0,22.5,15,12.5,12.5,0,0,0,10,27.5ZM22.5,38.333a10.8,10.8,0,0,1-7.744-3.269,2.481,2.481,0,0,1,1.912-.894,2.437,2.437,0,0,1,1.538.556.833.833,0,0,0,1.279-.292,3.354,3.354,0,0,1,2.708-1.908,8.281,8.281,0,0,1-.456,1.3.833.833,0,1,0,1.519.683,10.083,10.083,0,0,0,.59-1.713,3.377,3.377,0,0,1,1.662,1.637.833.833,0,0,0,1.279.292,2.437,2.437,0,0,1,1.538-.556,2.481,2.481,0,0,1,1.912.894A10.8,10.8,0,0,1,22.5,38.333Zm.6-13.548a3.338,3.338,0,0,1,.812-2.4,3.935,3.935,0,0,1,2.95-.417.108.108,0,0,1,.054.065,3.956,3.956,0,0,1-.806,2.858,3.9,3.9,0,0,1-2.885.427Zm-1.488.935a3.9,3.9,0,0,1-2.75.931,3.71,3.71,0,0,1-2.029-2.167.129.129,0,0,1,.019-.1,4.638,4.638,0,0,1,2.4-1.015,1.66,1.66,0,0,1,.406.048,3.406,3.406,0,0,1,1.813,1.756ZM33.333,27.5a10.756,10.756,0,0,1-2.013,6.265A4.142,4.142,0,0,0,28.331,32.5a4.09,4.09,0,0,0-1.787.417,5.046,5.046,0,0,0-2.417-1.8,12.385,12.385,0,0,0-.35-4.06c.167.012.333.027.513.027a4.394,4.394,0,0,0,2.917-.931,5.385,5.385,0,0,0,1.375-4.177,1.76,1.76,0,0,0-1.438-1.642,5.348,5.348,0,0,0-4.329.8,3.783,3.783,0,0,0-1.05,1.658,3.733,3.733,0,0,0-1.7-.988,5.248,5.248,0,0,0-4.212,1.25,1.775,1.775,0,0,0-.527,2.14,5.285,5.285,0,0,0,3.131,3.073,3.367,3.367,0,0,0,.8.1,5.454,5.454,0,0,0,2.862-.983,11,11,0,0,1,.333,3.462,5.015,5.015,0,0,0-4,2.079,4.09,4.09,0,0,0-1.787-.423,4.142,4.142,0,0,0-2.988,1.265A10.827,10.827,0,1,1,33.333,27.5Z",
                  transform: "translate(-1.716 -2.5)"
                }
              }),
              h("path", {
                attrs: {
                  d: "M7.879,12.121A42.954,42.954,0,0,1,21.961,9.669a42.954,42.954,0,0,1,14.083,2.452A.833.833,0,0,0,36.6,10.55a43.508,43.508,0,0,0-29.271,0,.833.833,0,0,0,.556,1.571Z",
                  transform: "translate(-1.178 -1.335)"
                }
              }),
              h("path", {
                attrs: {
                  d: "M7.325,48.619a43.317,43.317,0,0,0,29.271,0,.833.833,0,1,0-.556-1.571A42.954,42.954,0,0,1,21.961,49.5,42.954,42.954,0,0,1,7.878,47.048a.833.833,0,1,0-.556,1.571Z",
                  transform: "translate(-1.178 -7.833)"
                }
              }),
            ])
          ]),
        ])
      ]);
  }
};

var AgriculturaPrecisaoIcon = {
  name: 'AgriculturaPrecisaoIcon',
  props: {
    size: {
      type: String,
      default: '28',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
        attrs: {
          xmlns: "http://www.w3.org/2000/svg",
          width: "60",
          height: "60",
          viewBox: "0 0 60 60",
        },
        "class": "feather"
      }, ctx.data]),
      [
        h("g", {attrs: {transform: "translate(-120 -180)"}}, [
          h("g", {attrs: {transform: "translate(125 187)"}}, [
            h("path", {
              attrs: {
                d: "M2.267,8.329a4.938,4.938,0,0,0-.483,2.2A4.281,4.281,0,0,0,6.061,14.8a5.164,5.164,0,0,0,2.213-.468L2.267,8.329m-.615-3.14.485.485h0Zm.485.485.728.728,8.1,8.1a6.2,6.2,0,0,1-4.9,2.09A6.061,6.061,0,0,1,0,10.527,6.009,6.009,0,0,1,2.137,5.674Z",
                transform: "translate(14.768 18.635)"
              }
            }),
            h("path", {
              attrs: {
                d: "M3.695,8.514A9.06,9.06,0,0,0,1.785,14.3,8.651,8.651,0,0,0,10.5,22.864a9.839,9.839,0,0,0,5.92-1.811L3.695,8.514M2.863,5.189l.84.827h0Zm.84.827L4.965,7.26,19,21.081A10.807,10.807,0,0,1,10.5,24.649,10.426,10.426,0,0,1,0,14.3,10.213,10.213,0,0,1,3.7,6.016Z",
                transform: "translate(10.172 15.219)"
              }
            }),
            h("path", {
              attrs: {
                d: "M5.013,8.78a11.508,11.508,0,0,0-1.1,1.407,13.23,13.23,0,0,0-2.132,7.452A12.474,12.474,0,0,0,14.35,29.99a14.323,14.323,0,0,0,7.677-2.072,12.117,12.117,0,0,0,1.392-1.006L5.013,8.78m-1.1-3.591,1.147,1.13h0Zm1.147,1.13,1.724,1.7L25.952,26.9s-3.676,4.874-11.6,4.874A14.245,14.245,0,0,1,0,17.639C0,9.837,5.051,6.324,5.059,6.319Z",
                transform: "translate(6.327 12.012)"
              }
            }),
            h("path", {
              attrs: {
                d: "M3.689,0,0,2.035l34.908,26.3L36.047,25.7Z",
                transform: "translate(2.975 12.725) rotate(6.024)"
              }
            }),
            h("path", {
              attrs: {
                d: "M-17478.4-1378.642l6.354-6.158,16.025,16.052-2.373,2.4.949,1.087,5.936-5.74a.913.913,0,0,1,.713-.337.931.931,0,0,1,.715.336c.809.754,4.125,4.126,4.125,4.126a1.155,1.155,0,0,1,.514.885,1.156,1.156,0,0,1-.381.954c-.967,1.031-5.68,5.629-5.68,5.629l1.031,1.058,2.566-2.424,15.939,16.163-6.1,6.131-16.24-16.05,2.479-2.34-1.2-1.142-1.787,1.785a.859.859,0,0,1-.668.316.868.868,0,0,1-.67-.315c-.727-.725-1.143-1.2-1.143-1.2s-.5-.357-.865,0l-2.031,2.006,1.109.893s-2.086,2.174-3.59.194a2.239,2.239,0,0,1-.57-1.733,2.253,2.253,0,0,1,.9-1.584l.779,1.059,2.285-2.09s.582-.391.191-.725-1.479-1.365-1.479-1.365a1.076,1.076,0,0,1,0-1.476,20.963,20.963,0,0,1,1.814-1.589l-1.055-1.2-2.312,2.479Z",
                transform: "translate(17481.967 1384.8)"
              }
            }),
          ]),
        ])
      ]);
  }
};

var PlaylistIcon = {
  name: 'PlaylistIcon',
  props: {
    size: {
      type: String,
      default: '28',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18.373",
        height: "14.199",
        viewBox: "0 0 18.373 14.199",
      },
      "class": "feather"
    }, ctx.data]), [
      h("g", {attrs: {transform: "translate(-376 -423)"}}, [
        h("g", {attrs: {transform: "translate(377 424)"}}, [
          h("path", {
            attrs: {
              d: "M11.036,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H11.036a1,1,0,0,1,1,1A1,1,0,0,1,11.036,1Z",
              transform: "translate(4.245 0)"
            }
          }),
          h("path", {
            attrs: {
              d: "M3.806,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H3.806a1,1,0,0,1,1,1A1,1,0,0,1,3.806,1Z",
              transform: "translate(4.244 5.093)"
            }
          }),
          h("path", {
            attrs: {
              d: "M3.806,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H3.806a1,1,0,0,1,1,1A1,1,0,0,1,3.806,1Z",
              transform: "translate(4.244 10.188)"
            }
          }),
          h("path", {
            attrs: {
              d: "M.008,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H.008a1,1,0,0,1,1,1A1,1,0,0,1,.008,1Z",
              transform: "translate(0 0)"
            }
          }),
          h("path", {
            attrs: {
              d: "M.008,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H.008a1,1,0,0,1,1,1A1,1,0,0,1,.008,1Z",
              transform: "translate(0 5.094)"
            }
          }),
          h("path", {
            attrs: {
              d: "M.008,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H.008a1,1,0,0,1,1,1A1,1,0,0,1,.008,1Z",
              transform: "translate(0 10.187)"
            }
          }),
        ]),

        h("path", {
          attrs: {
            d: "M5,3,8.961,7.049,5,11.1Z",
            transform: "translate(384.411 425.101)"
          }
        }),

        h("path", {
          attrs: {
            d: "M5,2a1,1,0,0,1,.715.3L9.676,6.35a1,1,0,0,1,0,1.4L5.715,11.8A1,1,0,0,1,4,11.1V3A1,1,0,0,1,5,2ZM7.562,7.049,6,5.452V8.646Z",
            transform: "translate(384.411 425.101)"
          }
        }),


      ]),

    ]);
  }
};

var FaceIdIcon = {
  name: 'FaceIdIcon',
  props: {
    size: {
      type: String,
      default: '28',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "20",
        height: "20 ",
        viewBox: "0 0 20 20",
      },
      "class": "feather"
    }, ctx.data]), [
      h("path", {
        attrs: {
          d: "M1.029,5.486V3.257A2.194,2.194,0,0,1,3.257,1.029H5.486A.514.514,0,0,0,5.486,0H3.257A3.222,3.222,0,0,0,0,3.257V5.486a.514.514,0,0,0,1.029,0Z",
          stroke: "currentColor",
        }
      }),

      h("g", {attrs: {transform: "translate(0 14)"}}, [
        h("path", {
          attrs: {
            d: "M1.029-23.486v2.229a2.194,2.194,0,0,0,2.229,2.229H5.486A.514.514,0,0,1,6-18.514.514.514,0,0,1,5.486-18H3.257A3.222,3.222,0,0,1,0-21.257v-2.229A.514.514,0,0,1,.514-24,.514.514,0,0,1,1.029-23.486Z",
            transform: "translate(0 24)",
            stroke: "currentColor",
          }
        }),
      ]),

      h("g", {attrs: {transform: "translate(20 6) rotate(180)"}}, [
        h("path", {
          attrs: {
            d: "M1.029.514V2.743A2.194,2.194,0,0,0,3.257,4.971H5.486A.514.514,0,0,1,5.486,6H3.257A3.222,3.222,0,0,1,0,2.743V.514a.514.514,0,0,1,1.029,0Z",
            stroke: "currentColor",
          }
        }),
      ]),

      h("g", {attrs: {transform: "translate(20 20) rotate(180)"}}, [
        h("path", {
          attrs: {
            d: "M1.029,5.486V3.257A2.194,2.194,0,0,1,3.257,1.029H5.486A.514.514,0,0,0,5.486,0H3.257A3.222,3.222,0,0,0,0,3.257V5.486a.514.514,0,0,0,1.029,0Z",
            stroke: "currentColor",
          }
        }),
      ]),

      h("g", {attrs: {transform: "translate(5.439 7.018)"}}, [
        h("path", {
          attrs: {
            d: "M0,.536V1.965A.519.519,0,0,0,.5,2.5.519.519,0,0,0,1,1.965V.536A.519.519,0,0,0,.5,0,.519.519,0,0,0,0,.536Z",
            stroke: "currentColor",
          }
        }),
      ]),

      h("g", {attrs: {transform: "translate(13.684 7.018)"}}, [
        h("path", {
          attrs: {
            d: "M0,.536V1.965A.519.519,0,0,0,.5,2.5.519.519,0,0,0,1,1.965V.536A.519.519,0,0,0,.5,0,.519.519,0,0,0,0,.536Z",
            stroke: "currentColor",
          }
        }),
      ]),

      h("path", {
        attrs: {
          d: "M25.43,56.35a5.2,5.2,0,0,0,7.034,0,.526.526,0,1,0-.718-.77,4.148,4.148,0,0,1-5.6,0,.526.526,0,0,0-.718.77Z",
          transform: "translate(-18.947 -41.579)",
          stroke: "currentColor",
        }
      }),

      h("path", {
        attrs: {
          d: "M36.316,28.6v3.684a.309.309,0,0,1-.352.351h-.35a.526.526,0,1,0,0,1.053h.35a1.353,1.353,0,0,0,1.4-1.4V28.6a.526.526,0,0,0-1.053,0Z",
          transform: "translate(-26.316 -21.053)",
          stroke: "currentColor",
        }
      }),
    ]);
  }
};

var TouchIdIcon = {
  name: 'TouchIdIcon',
  props: {
    size: {
      type: String,
      default: '28',
      validator: function validator(s) {
        return !isNaN(s) || s.length >= 2 && !isNaN(s.slice(0, s.length - 1)) && s.slice(-1) === 'x';
      }
    }
  },
  functional: true,
  render: function render(h, ctx) {
    var size = ctx.props.size.slice(-1) === 'x' ? ctx.props.size.slice(0, ctx.props.size.length - 1) + 'em' : parseInt(ctx.props.size) + 'px';
    var attrs = ctx.data.attrs || {};
    attrs.width = attrs.width || size;
    attrs.height = attrs.height || size;
    ctx.data.attrs = attrs;
    return h("svg", _mergeJSXProps([{
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18",
      },
      "class": "feather"
    }, ctx.data]), [
      h("g", {attrs: {transform: "translate(-4673.104 -12686.13)"}}, [

        h("path", {
          attrs: {
            d: "M4677.047,12732.208s-7.735-11.071.953-15.98,14.631,6.525,11.143,8.334-2.293-2.357-4.134-4.36-5.1-1.131-6.2.419-2.648,5.362,4.845,11.273",
            stroke: "currentColor",
            transform: "translate(0 -28)",
            fill: "none",
            'stroke-width': 1.5,
          }
        }),

        h("path", {
          attrs: {
            d: "M4681.814,12722.34s1.55,8.171,8.85,7.913",
            stroke: "currentColor",
            transform: "translate(0 -28)",
            fill: "none",
            'stroke-width': 1.5,
          }
        }),
      ])

    ]);
  }
};

export {
  AllIcon,
  AcucarIcon,
  AlgodaoIcon,
  ArrozIcon,
  BioenergiaIcon,
  BoiIcon,
  CafeIcon,
  ChicagoIcon,
  FareloIcon,
  FeijaoIcon,
  FrangoIcon,
  MilhoIcon,
  SojaIcon,
  SuinoIcon,
  TrigoIcon,
  LatamIcon,
  SafrasTvIcon,
  SafrasPodcastIcon,
  CursosIcon,
  PalestrasIcon,
  CambioIcon,
  ConsultoriaIcon,
  NewsIcon,
  FutureMarketIcon,
  FisicoIcon,
  IndicadoresIcon,
  ClimaIcon,
  MeusAtivosIcon,
  WhatsHedgeIcon,
  HedgeCommoditiesIcon,
  HedgeCambialIcon,
  HedgeIcon,
  FertilizerIcon,
  AgriculturaPrecisaoIcon,
  PlaylistIcon,
  FaceIdIcon,
  TouchIdIcon,
};
